<template>
  <v-row
      align-center
      justify-center
      :class="{ fullSize: loading }"
      class="mx-0"
  >
    <v-col class="pa-0 generalClass-table-padding">
      <loading-page v-if="loading"></loading-page>

      <default-page
          v-else-if="error || !definitions.length"
          imageUrl="/img/dynamic-src-images/configurations-2.svg"
          title="Configurations"
          text="It seems that you don't have any configurations|Click Get Started below to add a configuration"
          :buttonText="error ? 'Reload' : 'Get Started'"
          :errorMessage="error ? errorMessage.message : ''"
          @button-clicked="getStarted"
      ></default-page>

      <div v-else>
        <confirm-dialog
            :dialog="confirmDialog"
            @confirmation-event="
            cantDelete ? terminateAndDeleteConfig($event) : deleteConfig($event)
          "
            @mutate-confirm-dialog="mutateConfirmDialog"
            :text="itemDeletionText"
            :text2="itemDeletionText2"
            :acceptButton="'Delete'"
            :cantDelete="cantDelete"
        ></confirm-dialog>

        <v-dialog
            v-model="journalFiltersDialogModel"
            transition="scroll-x-transition"
            overlay-color="grey darken-2"
            content-class="ec-confirmation-dialog overflowY-auto"
            width="600"
            persistent
        >
          <v-card color="accent" width="600">
            <v-card-title
                v-if="currentJournalFilter"
                dark
                style="background-color: #47bd96; color: white"
            >
              Editing filter: {{ currentJournalFilter.Name }}
            </v-card-title>
            <v-card-text class="pb-0 pt-5 text-center">
              <v-row v-if="currentJournalFilter">
                <v-col
                    v-for="field in journalFilterFields"
                    :key="field.name"
                    cols="12"
                    sm="6"
                    class="pb-0 pt-1"
                >
                  <v-text-field
                      v-if="
                      field.type === 'textfield' && field.valueType === 'text'
                    "
                      v-model="currentJournalFilter[field.name]"
                      dense
                      outlined
                      :label="field.name"
                  >
                  </v-text-field>
                  <v-text-field
                      v-if="
                      field.type === 'textfield' && field.valueType === 'number'
                    "
                      v-model.number="currentJournalFilter[field.name]"
                      type="number"
                      dense
                      outlined
                      :label="field.name"
                  >
                  </v-text-field>

                  <v-select
                      v-else-if="field.type === 'group'"
                      ref="vSelectParsers"
                      v-model="selectedJournalFilterParsers"
                      :items="currentJournalFilter.Parsers"
                      :menu-props="{
                      offsetY: true,
                      bottom: true,
                      maxHeight: '250',
                    }"
                      dense
                      outlined
                      return-object
                      item-text="Name"
                      item-value="id"
                      multiple
                      :label="field.name"
                  >
                    <template v-slot:no-data
                    >
                      <div style="border-top: none !important"></div
                      >
                    </template>
                    <template v-slot:prepend-item>
                      <v-list-item
                          @click="addCustomParser"
                          style="
                          max-height: 40px;
                          border-bottom: 1px solid #7f7f7f;
                        "
                          ripple
                      >
                        <v-list-item-content>
                          <v-list-item-title
                              style="font-size: 14px !important; font-weight: 400"
                          >
                            <i
                                style="color: #47bd96"
                                class="fas fa-plus-circle mr-1"
                            ></i>
                            Custom parser
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                    <template v-slot:item="{ item }">
                      <div class="mb-0 char-lim-tabs">
                        <div>{{ item.Name }}</div>
                      </div>
                      <v-spacer style="border-top: none !important"></v-spacer>
                      <v-btn
                          @click.stop="editCustomJournalFilterParser(item)"
                          small
                          icon
                          class="mr-1"
                          style="margin-top: 1px"
                      >
                        <span
                            style="font-size: 27px; margin-bottom: 2px"
                            class="icon-edit-21x21"
                        >
                          <span class="path1 letterSpacing0"></span>
                          <span class="path2"></span>
                        </span>
                      </v-btn>
                      <v-btn
                          @click.stop="deleteCustomJournalFilterParser(item)"
                          small
                          style="margin-top: 1px"
                          icon
                      >
                        <span
                            class="icon-delete-21x21"
                            style="font-size: 27px; margin-bottom: 2px"
                        >
                          <span class="path1 letterSpacing0"></span>
                          <span class="path2"></span>
                        </span>
                      </v-btn>
                    </template>
                  </v-select>
                </v-col>
              </v-row>
              <p v-else>Oops! Something went wrong...</p>
              <p v-if="currentParserEditing" class="text-start ml-1">
                Custom Parser: {{ currentParserEditing.Name }}
              </p>
              <v-row v-if="currentParserEditing">
                <v-col
                    v-for="parserField in journalFilterParserFields"
                    :key="parserField.id"
                    cols="12"
                    sm="6"
                    class="pb-0 pt-1"
                >
                  <v-text-field
                      v-if="parserField.type === 'textfield'"
                      v-model="currentParserEditing[parserField.name]"
                      dense
                      outlined
                      :label="parserField.name"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions class="pt-0">
              <v-spacer></v-spacer>
              <v-btn text @click="journalFiltersDialogModel = false"
              >Cancel
              </v-btn
              >
              <v-btn color="primary" text @click="saveJournalFilter"
              >Save
              </v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>

        <quote-connection-edit-dialog
            @update-quote-dialog="(ev) => (quoteConnectionEditDialog = ev)"
            @save-quote-connection="saveQuoteConnection"
            @add-encryption-method="(method) => currentEncryptionMethods.unshift(method)"
            :quoteConnectionEditDialog="quoteConnectionEditDialog"
            :quoteConnectionType="quoteConnectionSelected"
            :currentEncryptionMethods="currentEncryptionMethods"
            :currentDefinition="currentDefinition"
        />
        <v-row no-gutters>
          <v-col cols="12">
            <v-data-table
                :mobile-breakpoint="0"
                :height="`${
                $vuetify.breakpoint.mdAndUp
                  ? windowSizeY - 100
                  : windowSizeY - 96
              }px`"
                :items-per-page="itemsPerPage"
                :page.sync="page"
                fixed-header
                :custom-sort="currentSortingAlgo"
                hide-default-header
                hide-default-footer
                dense
                :headers="headers"
                sort-by="id"
                :items="tableItems"
                single-expand
                :expanded.sync="expanded"
                class="main_page_table"
            >
              <template v-slot:header="{ props: { headers } }">
                <thead>
                <tr>
                  <th
                      v-for="header in headers.filter((el, index) => {
                        return index + 1 <= headersCounter;
                      })"
                      :key="header.value"
                      class="allTableHeaders"
                  >
                    <v-row>
                      <v-col height="100%">
                        <v-row
                            :class="
                              header.value === 'configuration' ? 'pl-0' : 'pl-3'
                            "
                            :style="
                              header.value === 'configuration' ||
                              headersCounter === 1
                                ? 'justify-content: center;'
                                : ''
                            "
                        >
                          <v-hover v-slot:default="{ hover }">
                            <p
                                :class="
                                  header.value === 'configuration'
                                    ? 'text-center'
                                    : 'allTableHeadersHover'
                                "
                                class="my-0 fullHeight"
                                @click="
                                  currentSortingAlgo =
                                    getNewSortingAlgo(header);
                                  selectedHeader = header.value;
                                "
                            >
                              {{ header.text }}
                              <v-icon
                                  v-show="header.value !== 'configuration'"
                                  :style="
                                    !hover && (selectedHeader !== header.value)
                                      ? 'opacity: 0.5;'
                                      : 'opacity: 1;'
                                  "
                                  style="font-size: 12px; margin-left: 2px"
                                  color="#a693f3"
                              >{{
                                  getSortingIcon(header.currentSortAlg)
                                }}
                              </v-icon
                              >
                            </p>
                          </v-hover>
                        </v-row>
                      </v-col>
                    </v-row>
                  </th>
                </tr>
                </thead>
              </template>
              <template v-slot:item="{ item, index }">
                <tr
                    @click="expandRow(item)"
                    :id="
                    $vuetify.theme.dark
                      ? 'dataTableRow_dark'
                      : 'dataTableRow_light'
                  "
                    class="table_Row rowClick"
                >
                  <td
                      v-for="(header, index) in headersCounter !== headers.length
                      ? headersCounter
                      : headersCounter - 1"
                      :key="index"
                  >
                    <v-row>
                      <p
                          v-if="headersCounter === 1"
                          :style="`margin-left: 30% !important;`"
                      ></p>
                      <v-icon
                          v-if="
                          headers[index].value === 'name' &&
                          headersCounter !== headers.length
                        "
                          :class="
                          expanded.some((el) => el.id === item.id)
                            ? 'red--text pr-1 ml-2'
                            : 'primary--text pr-1 ml-2'
                        "
                          style="font-size: 16px"
                      >
                        {{
                          expanded.some((el) => el.id === item.id)
                              ? "fas fa-times-circle"
                              : "fas fa-chevron-circle-down"
                        }}
                      </v-icon>
                      <v-tooltip
                          v-if="
                          headers[index].value !== 'application.name' &&
                          headers[index].value !== 'server.name'
                        "
                          :disabled="
                          !isAdmin ||
                          isNotDesktop ||
                          headers[index].value !== 'name'
                        "
                          bottom
                      >
                        <template v-slot:activator="{ on }">
                          <p
                              v-on="on"
                              :class="getCellTextClass(headers[index].value)"
                          >
                            {{ item[headers[index].value] }}
                          </p>
                        </template>
                        <span>
                          <div v-if="item.id">ID: {{ item.id }}</div>
                        </span>
                      </v-tooltip>

                      <p
                          v-else
                          style="margin-bottom: 3px"
                          class="d-inline ml-3"
                      >
                        {{
                          item[getProperties(headers[index].value, true)][
                              getProperties(headers[index].value, false)
                              ]
                        }}
                      </p>
                    </v-row>
                  </td>
                  <td
                      v-if="headersCounter === headers.length"
                      class="text-center"
                  >
                    <v-btn
                        :id="`edit-config${index}`"
                        icon
                        @click="editConfiguration(item)"
                    >
                      <span style="font-size: 28px" class="icon-edit-21x21">
                        <span class="path1 letterSpacing0"></span>
                        <span class="path2"></span>
                      </span>
                    </v-btn>
                    <v-tooltip
                        :activator="`#edit-config${index}`"
                        class="mt-3 ml-1"
                        bottom
                    >
                      <span>Edit</span>
                    </v-tooltip>

                    <v-badge
                        offset-x="18"
                        offset-y="12"
                        :class="{ 'badge-small': item.cantDelete }"
                        :value="item.cantDelete"
                        color="red"
                        icon="fas fa-exclamation"
                    >
                      <v-btn
                          :id="`delete-config${index}`"
                          icon
                          @click="confirmationDialog(item)"
                      >
                        <span style="font-size: 28px" class="icon-delete-21x21">
                          <span class="path1 letterSpacing0"></span>
                          <span class="path2"></span>
                        </span>
                      </v-btn>
                    </v-badge>
                    <v-tooltip
                        :activator="`#delete-config${index}`"
                        class="mt-3 ml-1"
                        bottom
                    >
                      <span>Delete</span>
                    </v-tooltip>
                  </td>
                </tr>
              </template>

              <template v-slot:expanded-item="{ item }">
                <tr
                    v-for="(headerIndex, index) in headers.length -
                  headersCounter"
                    :key="index"
                    class="expandBackground"
                >
                  <v-row
                      style="height: 32px"
                      class="expandRowClass_Border mx-0 table_Row"
                  >
                    <v-col
                        v-if="$vuetify.breakpoint.width < 411"
                        cols="1"
                    ></v-col>
                    <v-col class="py-0 pl-2pr-0" cols="3">
                      <p
                          class="ml-1 my-1"
                          style="font-weight: 600; font-size: 14px"
                      >
                        {{ headers[index + headersCounter].text }}
                      </p>
                    </v-col>
                    <v-col class="py-0" cols="8">
                      <p
                          v-if="
                          headers[index + headersCounter].value ===
                            'application.name' ||
                          headers[index + headersCounter].value === 'server.name'
                        "
                          class="ml-1 my-1 text-center"
                          style="font-size: 14px"
                      >
                        {{
                          item[
                              getProperties(
                                  headers[index + headersCounter].value,
                                  true
                              )
                              ][
                              getProperties(
                                  headers[index + headersCounter].value,
                                  false
                              )
                              ]
                        }}
                      </p>
                      <p
                          v-else-if="
                          headerIndex < headers.length - headersCounter
                        "
                          class="ml-1 my-1 text-center char-lim-mobile"
                          style="font-size: 14px"
                      >
                        {{ item[headers[index + headersCounter].value] }}
                      </p>

                      <div v-else class="text-center">
                        <v-tooltip
                            :disabled="isNotDesktop"
                            class="mt-3 ml-1"
                            bottom
                        >
                          <template v-slot:activator="{ on }">
                            <v-btn
                                height="32"
                                width="32"
                                icon
                                @click="editConfiguration(item)"
                                v-on="on"
                            >
                              <span
                                  style="font-size: 28px"
                                  class="icon-edit-21x21"
                              >
                                <span class="path1 letterSpacing0"></span>
                                <span class="path2"></span>
                              </span>
                            </v-btn>
                          </template>
                          <span>Edit</span>
                        </v-tooltip>
                        <v-tooltip :disabled="isNotDesktop" class="mt-3" bottom>
                          <template v-slot:activator="{ on }">
                            <v-btn
                                height="32"
                                width="32"
                                icon
                                @click="confirmationDialog(item)"
                                v-on="on"
                            >
                              <span
                                  style="font-size: 28px"
                                  class="icon-delete-21x21"
                              >
                                <span class="path1 letterSpacing0"></span>
                                <span class="path2"></span>
                              </span>
                            </v-btn>
                          </template>
                          <span>Delete</span>
                        </v-tooltip>
                      </div>
                    </v-col>
                  </v-row>
                  <td
                      v-for="header in headersCounter - 1"
                      :key="header"
                      style="border: none"
                  ></td>
                </tr>
              </template>
              <template v-slot:no-data>
                <v-alert :value="true" color="primary" icon="warning" outlined>
                  It seems that you don't have any configurations. Click at
                  <v-icon>add</v-icon>&nbsp;to create a configuration!
                </v-alert>
              </template>
            </v-data-table>
            <div class="text-center custom-table-footer">
              <v-row justify="space-between" justify-sm="end" class="mx-0">
                <div class="ml-2 pagination-item-1">
                  <div v-if="$vuetify.breakpoint.smAndUp" class="mr-6">
                    Rows per page:
                  </div>
                  <div
                      :class="{ 'mr-1': $vuetify.breakpoint.smAndUp }"
                      class="footer-items-wrapper"
                  >
                    <v-select
                        dense
                        class="footer-items-per-page mt-0"
                        hide-details
                        :menu-props="{ top: true, offsetY: true }"
                        :items="[10, 25, 50, 100]"
                        v-model="itemsPerPage"
                        @change="paginationChangeHandler(1)"
                    >
                      <template v-slot:item="{ item }">
                        <div class="mb-0 char-lim-tabs page-rows-selection">
                          <div v-if="item === -1">All</div>
                          <div v-else>{{ item }}</div>
                        </div>
                      </template>
                      <template v-slot:selection="{ item }">
                        <div class="page-rows-selection">
                          <div v-if="item === -1">All</div>
                          <div v-else>
                            {{ item }}
                          </div>
                        </div>
                      </template>
                    </v-select>
                  </div>
                </div>
                <v-pagination
                    v-model="page"
                    @input="paginationChangeHandler"
                    :length="totalPages"
                    :total-visible="$vuetify.breakpoint.xsOnly ? 5 : 7"
                    circle
                    class="pagination"
                ></v-pagination>
              </v-row>
            </div>
          </v-col>
        </v-row>
      </div>
      <v-btn
          v-if="(definitions.length > 0) && (isAdmin === true)"
          fab
          bottom
          right
          :style="{ bottom: '70px' }"
          :color="$vuetify.theme.dark ? '#685AA1' : 'primary'"
          dark
          fixed
          @click="openDefinitionDialog"
      >
        <v-icon>add</v-icon>
      </v-btn>

      <v-dialog
          transition="scroll-x-transition"
          overlay-color="grey darken-2"
          v-model="dialog"
          content-class="configurations-dialog"
          width="750px"
          scrollable
          persistent
      >
        <v-card class="accent">
          <v-card-title dark style="background-color: #47bd96; color: white">
            Application Configuration
            <!-- Application Configuration {{edit ? ` - Server: ${currentDefinition.server.name}` : ''}} -->
          </v-card-title>
          <v-form
              ref="confForm"
              v-model="valid"
              class="pt-4"
              style="overflow-y: auto; margin-bottom: 14px"
          >
            <v-container class="py-0">
              <v-tabs-items
                  style="background-color: initial"
                  v-model="analyticsConfigModel"
              >
                <v-tab-item>
                  <v-row justify="center">
                    <v-col class="pb-0 pt-1" cols="12" sm="6">
                      <v-text-field
                          :autofocus="!currentDefinition.id"
                          class="textFieldOverride analyticsTextFieldClass"
                          dense
                          outlined
                          label="Configuration Name"
                          v-model="currentDefinition.name"
                          :rules="[rules.required, rules.maxCharName]"
                          hint="Max 50 characters"
                          counter
                      ></v-text-field>
                    </v-col>
                    <v-col class="pb-0 pt-1" cols="12" sm="6">
                      <v-text-field
                          class="analyticsTextFieldClass"
                          dense
                          outlined
                          label="Configuration Description"
                          v-model="currentDefinition.description"
                          counter
                          :rules="[rules.maxCharDescription]"
                          hint="Max 200 characters"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <!--START............... Selecting a server ............... -->
                    <v-col v-if="add" class="py-0" cols="12" sm="6">
                      <v-select
                          dense
                          outlined
                          v-model="chosenServer"
                          @change="serverSelected"
                          :menu-props="{ offsetY: true, maxHeight: '210' }"
                          :items="servers"
                          item-text="name"
                          item-value="id"
                          return-object
                          label="Server"
                          :rules="[rules.required]"
                      >
                        <template v-slot:item="{ item }">
                          <p class="mb-0">{{ item.name }}</p>
                        </template>
                      </v-select>
                    </v-col>

                    <v-col
                        v-else-if="currentDefinition.server"
                        class="py-0"
                        cols="12"
                        sm="6"
                    >
                      <v-text-field
                          autofocus
                          class="textFieldOverride analyticsTextFieldClass"
                          dense
                          outlined
                          disabled
                          label="Server"
                          v-model="currentDefinition.server.name"
                      ></v-text-field>
                    </v-col>
                    <!-- <v-col
                      v-if="
                        selectedApplicationType ==
                          applicationTypeEnums.pricewatcher && edit
                      "
                      class="py-0"
                      cols="12"
                      sm="6"
                    >
                        <v-select
                          outlined
                          dense
                          :menu-props="{
                            offsetY: true,
                            maxHeight: '250',
                          }"
                          :label="'Aliases'"
                          no-data-text="No aliases yet"
                          return-object
                          item-text="friendlyName"
                          item-value="id"
                        >
                          <template v-slot:prepend-item>
                            <v-list-item
                              @click="addAlias"
                              style="
                                max-height: 40px;
                                border-bottom: 1px solid #7f7f7f;
                              "
                              ripple
                            >
                              <v-list-item-content>
                                <v-list-item-title
                                  style="
                                    font-size: 14px !important;
                                    font-weight: 400;
                                  "
                                >
                                  <i
                                    style="color: #47bd96"
                                    class="fas fa-plus-circle mr-1"
                                  ></i>
                                  New alias
                                </v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </template>
                        </v-select>
                    </v-col> -->
                    <v-col v-if="add && isAdmin" class="py-0" cols="12" sm="6">
                      <v-select
                          dense
                          outlined
                          v-model="currentDefinition.executionType"
                          @change="executionTypeChanged"
                          :menu-props="{ offsetY: true, maxHeight: '210' }"
                          :items="executionTypes"
                          item-text="text"
                          item-value="value"
                          label="Execution type"
                          :rules="[rules.required]"
                      >
                        <template v-slot:item="{ item }">
                          <p class="mb-0">{{ item.text }}</p>
                        </template>
                      </v-select>
                    </v-col>

                    <v-col
                        v-if="
                        add &&
                        isAdmin &&
                        currentDefinition.executionType !== 'PROCESS'
                      "
                        class="py-0"
                        cols="12"
                        sm="6"
                    >
                      <v-select
                          dense
                          outlined
                          v-model="selectedApplicationType"
                          @change="applicationTypeChanged"
                          :menu-props="{ offsetY: true, maxHeight: '210' }"
                          :items="[
                          { text: 'Analytics', value: 1 },
                          { text: 'Price Watcher', value: 0 },
                        ]"
                          item-text="text"
                          item-value="value"
                          label="Application type"
                          :rules="[rules.required]"
                      >
                        <template v-slot:item="{ item }">
                          <p class="mb-0">{{ item.text }}</p>
                        </template>
                      </v-select>
                    </v-col>
                    <!--END............... Selecting a server ............... -->
                    <v-col
                        v-if="
                        selectedApplicationType ===
                          applicationTypeEnums.general && edit
                      "
                        class="py-0"
                        cols="12"
                        :sm="positionAppEnablers ? 12 : 6"
                    >
                      <v-row>
                        <v-col cols="6" class="pt-2">
                          <v-row
                              :justify="positionAppEnablers ? 'end' : 'center'"
                              :class="[
                              { 'mr-1': positionAppEnablers },
                              { 'primary--text': analyticsModel },
                            ]"
                          >
                            <v-icon
                                :class="{ 'primary--text': analyticsModel }"
                                class="mr-2"
                                style="
                                font-size: 17px;
                                height: 17px;
                                margin-top: 3px;
                              "
                            >icon-analytics-23x23
                            </v-icon
                            >
                            Analytics
                            <v-switch
                                v-model="analyticsModel"
                                small
                                hide-details
                                color="primary"
                                class="always-primary-checkbox alert-card-switch mt-0 pt-0 ml-2"
                                style="width: 40px; height: 20px"
                            ></v-switch>
                          </v-row>
                        </v-col>
                        <v-col
                            cols="6"
                            :class="{ 'pl-0': $vuetify.breakpoint.xsOnly }"
                            class="pt-2"
                        >
                          <v-row
                              :justify="positionAppEnablers ? 'start' : 'center'"
                              :class="[
                              { 'mr-1': positionAppEnablers },
                              { 'primary--text': priceGuardModel },
                            ]"
                          >
                            <v-icon
                                :class="{ 'primary--text': priceGuardModel }"
                                class="mr-2"
                                style="
                                font-size: 17px;
                                height: 17px;
                                margin-top: 3px;
                              "
                            >icon-price-guard-21x25
                            </v-icon
                            >
                            Price Guard
                            <v-switch
                                v-model="priceGuardModel"
                                small
                                hide-details
                                color="primary"
                                class="always-primary-checkbox alert-card-switch mt-0 pt-0 ml-2"
                                style="width: 40px; height: 20px"
                            ></v-switch>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <!-- The following require an Application Type to be selected. -->
                  <!-- <v-row v-show="selectedApplicationType == 0">

                  </v-row> -->
                  <v-row
                      v-if="
                      selectedApplicationType === applicationTypeEnums.general &&
                      add
                    "
                  >
                    <v-col
                        class="py-0"
                        cols="12"
                        :sm="positionAppEnablers ? 12 : 6"
                    >
                      <v-row>
                        <v-col cols="6" class="pt-2">
                          <v-row
                              :justify="positionAppEnablers ? 'end' : 'center'"
                              :class="[
                              { 'mr-1': positionAppEnablers },
                              { 'primary--text': analyticsModel },
                            ]"
                          >
                            <v-icon
                                :class="{ 'primary--text': analyticsModel }"
                                class="mr-2"
                                style="
                                font-size: 17px;
                                height: 17px;
                                margin-top: 3px;
                              "
                            >icon-analytics-23x23
                            </v-icon
                            >
                            Analytics
                            <v-switch
                                v-model="analyticsModel"
                                small
                                hide-details
                                color="primary"
                                class="always-primary-checkbox alert-card-switch mt-0 pt-0 ml-2"
                                style="width: 40px; height: 20px"
                            ></v-switch>
                          </v-row>
                        </v-col>
                        <v-col
                            cols="6"
                            :class="{ 'pl-0': $vuetify.breakpoint.xsOnly }"
                            class="pt-2"
                        >
                          <v-row
                              :justify="positionAppEnablers ? 'start' : 'center'"
                              :class="[
                              { 'mr-1': positionAppEnablers },
                              { 'primary--text': priceGuardModel },
                            ]"
                          >
                            <v-icon
                                :class="{ 'primary--text': priceGuardModel }"
                                class="mr-2"
                                style="
                                font-size: 17px;
                                height: 17px;
                                margin-top: 3px;
                              "
                            >icon-price-guard-21x25
                            </v-icon
                            >
                            Price Guard
                            <v-switch
                                v-model="priceGuardModel"
                                small
                                hide-details
                                color="primary"
                                class="always-primary-checkbox alert-card-switch mt-0 pt-0 ml-2"
                                style="width: 40px; height: 20px"
                            ></v-switch>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <div
                      v-else-if="
                      selectedApplicationType ===
                        applicationTypeEnums.pricewatcher && add
                    "
                  >
                    <div class="pl-2 pb-4 primary--text">
                      <v-icon
                          class="mr-2 mb-1"
                          color="primary"
                          style="font-size: 17px; height: 17px; margin-top: 2px"
                      >fas fa-chart-line
                      </v-icon
                      >
                      Price Watcher Configurations
                    </div>
                  </div>
                  <v-tabs
                      v-if="
                      selectedApplicationType === applicationTypeEnums.general
                    "
                      slider-color="accent"
                      background-color="accent"
                      centered
                      hide-slider
                      v-model="tab"
                      class="accent mt-2"
                      active-class="selectedTab-configs"
                      slider-size="height:36"
                  >
                    <v-tab class="accent" style="height: 36px !important">
                      <v-icon class="mr-2" style="font-size: 17px; height: 17px"
                      >icon-analytics-23x23
                      </v-icon
                      >
                      Analytics
                    </v-tab
                    >
                    <v-tab
                        @click="PGTabClicked(currentDefinition.id)"
                        class="accent"
                        style="height: 36px !important"
                    >
                      <v-icon
                          class="mr-2"
                          style="font-size: 17px; height: 17px"
                      >icon-price-guard-21x25
                      </v-icon
                      >
                      Price Guard
                    </v-tab
                    >
                    <v-tab
                        @click="PWTabClicked(currentDefinition.id)"
                        class="accent"
                        style="height: 36px !important"
                    >
                      <v-icon
                          class="mr-2"
                          style="font-size: 17px; height: 17px"
                      >fas fa-chart-line
                      </v-icon
                      >
                      Price Watcher
                    </v-tab
                    >
                    <v-tabs-items v-model="tab" class="accent mt-2">
                      <v-tab-item class="pt-2">
                        <v-row>
                          <v-col class="py-0" cols="12" sm="6">
                            <v-tooltip
                                :disabled="isNotDesktop"
                                content-class="tooltipClass"
                                bottom
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                    :disabled="!analyticsModel"
                                    class="analyticsTextFieldClass"
                                    dense
                                    outlined
                                    label="Symbol Split Pattern"
                                    v-model="
                                    currentDefinition.configuration.Analytics
                                      .SymbolSplitPattern
                                  "
                                    v-on="on"
                                ></v-text-field>
                              </template>
                              <span>
                                The regular expression which will use to extract
                                core symbol
                              </span>
                            </v-tooltip>
                          </v-col>
                          <v-col class="py-0" cols="12" sm="6">
                            <v-tooltip
                                :disabled="isNotDesktop"
                                content-class="tooltipClass"
                                bottom
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                    :disabled="!analyticsModel"
                                    class="analyticsTextFieldClass"
                                    dense
                                    outlined
                                    label="Calculation Currency"
                                    v-model="
                                    currentDefinition.configuration.Analytics
                                      .CalculationCurrency
                                  "
                                    :rules="
                                    !analyticsModel ? [] : [rules.required]
                                  "
                                    v-on="on"
                                ></v-text-field>
                              </template>
                              <span
                              >The name of the currency to use for
                                calculations</span
                              >
                            </v-tooltip>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col class="py-0" cols="12" sm="6">
                            <v-tooltip
                                :disabled="isNotDesktop"
                                content-class="tooltipClass"
                                bottom
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                    :disabled="!analyticsModel"
                                    dense
                                    outlined
                                    label="Group Mask"
                                    v-model="
                                    currentDefinition.configuration.Analytics
                                      .GroupMask
                                  "
                                    :rules="
                                    !analyticsModel ? [] : [rules.required]
                                  "
                                    v-on="on"
                                ></v-text-field>
                              </template>
                              <span>
                                A string e.g. "*,!demo"
                                <br/>Used to include or exclude records
                              </span>
                            </v-tooltip>
                          </v-col>
                          <v-col class="py-0">
                            <v-tooltip
                                v-if="isAdmin"
                                :disabled="isNotDesktop"
                                content-class="tooltipClassBig"
                                class="mt-3 ml-1"
                                bottom
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                    :disabled="!analyticsModel"
                                    class="analyticsTextFieldClass"
                                    dense
                                    outlined
                                    label="Execution Period Time"
                                    type="number"
                                    v-model.number="ExecutionPeriodTimeAN"
                                    @keydown="
                                    (ev) =>
                                      setHelperVar(ev, 'ExecutionPeriodTimeAN')
                                  "
                                    @keypress="
                                    (ev) =>
                                      setHelperVar(ev, 'ExecutionPeriodTimeAN')
                                  "
                                    @input="
                                    (ev) =>
                                      textInput(
                                        ev,
                                        currentDefinition.configuration,
                                        'ExecutionPeriodTime'
                                      )
                                  "
                                    @focusout="clearHelperVar"
                                    :rules="[rules.required]"
                                    v-on="on"
                                ></v-text-field>
                              </template>
                              <span>
                                The period of time where the application is
                                running in order to produce
                                <br/>all the grids (summary positions, summary
                                exposures), if we set <br/>ExecutionPeriodTime
                                = 5s means that the application will run every 5
                                seconds repeatedly
                              </span>
                            </v-tooltip>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col class="py-0" cols="12" sm="6">
                            <v-tooltip
                                v-if="isAdmin"
                                :disabled="isNotDesktop"
                                content-class="tooltipClassBig"
                                bottom
                            >
                              <template v-slot:activator="{ on }">
                                <div v-on="on">
                                  <v-select
                                      :disabled="!analyticsModel"
                                      outlined
                                      dense
                                      :menu-props="{ offsetY: true }"
                                      item-text="text"
                                      v-on="on"
                                      label="Minify Messages"
                                      v-model="MinifyANMessages"
                                      :items="[
                                      { value: true, text: 'Yes' },
                                      { value: false, text: 'No' },
                                    ]"
                                  >
                                    <template v-slot:item="{ item }">
                                      <p class="mb-0">{{ item.text }}</p>
                                    </template>
                                  </v-select>
                                </div>
                              </template>
                              <span>
                                Determines if publisher analytics messages
                                will be zipped by the agent
                              </span>
                            </v-tooltip>
                          </v-col>
                          <v-col class="py-0" cols="12" sm="6">
                            <v-tooltip
                                v-if="isAdmin"
                                :disabled="isNotDesktop"
                                content-class="tooltipClassBig"
                                bottom
                            >
                              <template v-slot:activator="{ on }">
                                <div v-on="on">
                                  <InputWrapper
                                      label="Enable Recovery Mode"
                                      container-class="ma-0"
                                      label-background="rgb(21, 21, 26)"
                                      dense
                                  >
                                    <v-switch
                                        :disabled="!analyticsModel"
                                        v-model="currentDefinition.configuration.EnableRecoveryMode"
                                        :label="currentDefinition.configuration.EnableRecoveryMode === true ? 'Yes' : 'No'"
                                        outlined
                                        dense
                                        v-on="on"
                                        hide-details
                                    ></v-switch>
                                  </InputWrapper>
                                </div>
                              </template>
                              <span>
                                Enable recovery mode
                              </span>
                            </v-tooltip>
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col class="pb-2 pt-0" cols="12" sm="6">
                            <v-tooltip
                                :disabled="!analyticsModel || isNotDesktop"
                                content-class="tooltipClass"
                                bottom
                            >
                              <template v-slot:activator="{ on }">
                                <div v-on="on">
                                  <v-select
                                      dense
                                      :menu-props="{
                                      offsetY: true,
                                      maxHeight: '250',
                                    }"
                                      :disabled="
                                      !currentDefinition.configuration.Analytics
                                        .ExecutionMappings.length ||
                                      !analyticsModel
                                    "
                                      return-object
                                      :label="
                                      currentDefinition.configuration.Analytics
                                        .ExecutionMappings.length
                                        ? `Select an execution mapping: ${currentDefinition.configuration.Analytics.ExecutionMappings.length}`
                                        : 'No execution mappings yet'
                                    "
                                      v-model="selectedExecutionMapping"
                                      :items="
                                      currentDefinition.configuration.Analytics
                                        .ExecutionMappings
                                    "
                                      item-text="Name"
                                      item-value="Id"
                                  >
                                    <template v-slot:item="{ item }">
                                      <p class="mb-0">{{ item.Name }}</p>
                                    </template>
                                  </v-select>
                                </div>
                              </template>
                              <span>
                                A list of execution mappings which will match
                                trades
                                <br/>into specific profiles (e.g. A-Book,
                                B-Book)
                              </span>
                            </v-tooltip>
                          </v-col>
                          <v-col class="pb-2 pt-0" cols="12" sm="6">
                            <v-btn
                                :disabled="!analyticsModel"
                                @click="
                                addExecutionMapping(
                                  currentDefinition.configuration.Analytics
                                    .ExecutionMappings.length
                                )
                              "
                                class="px-1 mt-1"
                                outlined
                                color="primary"
                                small
                            >
                              <v-icon
                                  style="font-size: 16px"
                                  class="mr-2"
                              >fas fa-plus-circle
                              </v-icon
                              >
                              Add Mapping
                            </v-btn>
                          </v-col>
                        </v-row>

                        <div v-if="selectedExecutionMapping != null">
                          <v-card
                              class="mb-3 exec-mapping"
                              :class="{
                              opacity0: addNewMapping,
                              opacity1sec: !addNewMapping,
                              'disabled-item': !analyticsModel,
                            }"
                              flat
                          >
                            <v-row justify-sm="space-between">
                              <v-col
                                  :class="
                                  $vuetify.breakpoint.smAndUp
                                    ? 'ml-5'
                                    : 'text-center'
                                "
                                  cols="11"
                                  sm="5"
                              >
                                <p style="font-size: 20px !important">
                                  {{ selectedExecutionMapping.Name }}
                                </p>
                              </v-col>
                              <v-spacer></v-spacer>
                            </v-row>
                            <v-row justify="center" justify-sm="space-between">
                              <v-col
                                  :class="
                                  $vuetify.breakpoint.smAndUp
                                    ? 'py-0 ml-5'
                                    : 'py-0'
                                "
                                  cols="11"
                                  sm="5"
                              >
                                <v-text-field
                                    dense
                                    outlined
                                    placeholder="ID"
                                    v-model="selectedExecutionMapping.Id"
                                    label="ID"
                                    disabled
                                ></v-text-field>
                              </v-col>
                              <v-col
                                  :class="
                                  $vuetify.breakpoint.smAndUp
                                    ? 'py-0 mr-5'
                                    : 'py-0'
                                "
                                  cols="11"
                                  sm="5"
                              >
                                <v-text-field
                                    :disabled="!analyticsModel"
                                    class="analyticsTextFieldClass"
                                    dense
                                    outlined
                                    placeholder="Name"
                                    v-model="selectedExecutionMapping.Name"
                                    label="Name"
                                    :rules="[rules.required]"
                                ></v-text-field>
                              </v-col>
                            </v-row>
                            <v-row justify="center" justify-sm="space-between">
                              <v-col
                                  :class="
                                  $vuetify.breakpoint.smAndUp
                                    ? 'py-0 ml-5'
                                    : 'py-0'
                                "
                                  cols="11"
                                  sm="5"
                              >
                                <v-text-field
                                    :disabled="!analyticsModel"
                                    class="analyticsTextFieldClass"
                                    dense
                                    outlined
                                    placeholder="Pattern"
                                    v-model="
                                    selectedExecutionMapping.SymbolPattern
                                  "
                                    label="Symbol Pattern"
                                ></v-text-field>
                              </v-col>
                              <v-col
                                  :class="
                                  $vuetify.breakpoint.smAndUp
                                    ? 'py-0 mr-5'
                                    : 'py-0'
                                "
                                  cols="11"
                                  sm="5"
                              >
                                <v-text-field
                                    :disabled="!analyticsModel"
                                    class="analyticsTextFieldClass"
                                    dense
                                    outlined
                                    placeholder="0"
                                    v-model="selectedExecutionMapping.Logins"
                                    label="Logins (e.g 3,4)"
                                ></v-text-field>
                              </v-col>
                            </v-row>
                            <v-row justify="center" justify-sm="space-between">
                              <v-col
                                  :class="
                                  $vuetify.breakpoint.smAndUp
                                    ? 'py-0 ml-5'
                                    : 'py-0'
                                "
                                  cols="11"
                                  sm="5"
                              >
                                <v-text-field
                                    :disabled="!analyticsModel"
                                    class="analyticsTextFieldClass"
                                    dense
                                    outlined
                                    placeholder="pattern"
                                    v-model="
                                    selectedExecutionMapping.GroupPattern
                                  "
                                    label="Group Pattern"
                                ></v-text-field>
                              </v-col>
                              <v-col
                                  :class="
                                  $vuetify.breakpoint.smAndUp
                                    ? 'py-0 mr-5'
                                    : 'py-0'
                                "
                                  cols="11"
                                  sm="5"
                              >
                                <v-text-field
                                    :disabled="!analyticsModel"
                                    class="analyticsTextFieldClass"
                                    dense
                                    outlined
                                    placeholder="mapping ID"
                                    v-model.number="
                                    selectedExecutionMapping.SplitExecutionMappingId
                                  "
                                    type="number"
                                    label="Split Execution Mapping ID"
                                    :rules="[rules.required]"
                                ></v-text-field>
                              </v-col>
                            </v-row>
                            <v-row justify="center" justify-sm="space-between">
                              <v-col
                                  :class="
                                  $vuetify.breakpoint.smAndUp
                                    ? 'py-0 ml-5'
                                    : 'py-0'
                                "
                                  cols="11"
                                  sm="5"
                              >
                                <v-text-field
                                    :disabled="!analyticsModel"
                                    class="analyticsTextFieldClass"
                                    dense
                                    outlined
                                    placeholder="0"
                                    v-model.number="
                                    selectedExecutionMapping.Percentage
                                  "
                                    type="number"
                                    label="Percentage (e.g 100)"
                                    :rules="[rules.required]"
                                ></v-text-field>
                              </v-col>
                              <v-col
                                  class="mb-2"
                                  align-self="end"
                                  :class="
                                  $vuetify.breakpoint.smAndUp ? 'py-0' : 'py-0'
                                "
                                  cols="11"
                                  sm="2"
                              >
                                <v-btn
                                    :disabled="!analyticsModel"
                                    text
                                    color="#ff1919"
                                    @click="deleteMapping"
                                >Delete
                                </v-btn
                                >
                              </v-col>
                            </v-row>
                          </v-card>
                        </div>
                      </v-tab-item>
                      <v-tab-item class="pt-2" style="min-height: 85px">
                        <div style="width: 100%" v-if="add">
                          <v-row justify="center">
                            <v-col cols="10">
                              <p class="mt-7 grey--text text-center">
                                <!-- You can add/remove symbols after you connect a server -->
                                Price Guard can be configured once created
                              </p>
                            </v-col>
                          </v-row>
                        </div>
                        <div v-if="!add" style="width: 100%">
                          <v-row>
                            <v-col cols="12" sm="6" class="py-0">
                              <v-tooltip
                                  :disabled="!priceGuardModel || isNotDesktop"
                                  content-class="tooltipClassBig"
                                  bottom
                              >
                                <template v-slot:activator="{ on }">
                                  <div v-on="on">
                                    <v-text-field
                                        :disabled="!priceGuardModel"
                                        class="analyticsTextFieldClass"
                                        dense
                                        outlined
                                        label="Cycle Time"
                                        v-model.number="CycleTime"
                                        @keydown="
                                        (ev) => setHelperVar(ev, 'CycleTime')
                                      "
                                        @keypress="
                                        (ev) => setHelperVar(ev, 'CycleTime')
                                      "
                                        @input="
                                        (ev) =>
                                          textInput(
                                            ev,
                                            currentDefinition.configuration,
                                            'CycleTime'
                                          )
                                      "
                                        @focusout="clearHelperVar"
                                        type="number"
                                        :rules="[rules.required]"
                                    ></v-text-field>
                                  </div>
                                </template>
                                <span>
                                  Time to check for tick updates in milliseconds
                                </span>
                              </v-tooltip>
                            </v-col>
                          </v-row>
                          <v-row justify="center">
                            <v-col
                                class="pb-0 pt-0 px-3"
                                style="max-height: 95px; margin-bottom: -1px"
                                cols="12"
                                sm="12"
                            >
                              <v-text-field
                                  :disabled="!priceGuardModel"
                                  v-model="searchSymbolPG"
                                  :value="searchSymbolPG"
                                  outlined
                                  :placeholder="
                                  regexSearchPG ? 'Search with regex' : 'Search'
                                "
                                  single-line
                                  dense
                                  :rules="regexSearchPG ? [rules.validRegex] : []"
                                  :class="
                                  regexSearchPG
                                    ? 'text-field-top-details'
                                    : 'hide-error-message'
                                "
                                  :hide-details="!regexSearchPG"
                                  class="inputSlot-mb-0"
                                  style="z-index: 0"
                              >
                                <template v-slot:append>
                                  <v-row class="mx-0">
                                    <p
                                        class="mb-0 mx-2 pt-1 grey--text subtitle-2"
                                    >
                                      ({{ currentPGSymbols }})
                                    </p>
                                    <v-btn
                                        @click="regexSearchPG = !regexSearchPG"
                                        icon
                                        small
                                        class="mb-2"
                                        :color="
                                        regexSearchPG ? 'primary' : 'white'
                                      "
                                    >
                                      <div
                                          class="absolute"
                                          style="left: 12px; font-size: 17px"
                                      >
                                        *
                                      </div>
                                      <div
                                          class="absolute"
                                          style="
                                          left: 5px;
                                          font-size: 25px;
                                          margin-bottom: 2px;
                                        "
                                      >
                                        .
                                      </div>
                                    </v-btn>
                                  </v-row>
                                </template>
                              </v-text-field>
                            </v-col>
                            <v-col class="pt-0 px-3" cols="12">
                              <v-data-table
                                  @current-items="
                                  (items) => setCurrentPGSymbols(items)
                                "
                                  ref="PGSymbolsTable"
                                  :mobile-breakpoint="0"
                                  id="selectSymbolsTable"
                                  :class="{
                                  'disabled-table': !priceGuardModel,
                                }"
                                  style="
                                  height: 238px;
                                  overflow-y: auto;
                                  border: 1px solid #47bd96;
                                  z-index: 1;
                                "
                                  dense
                                  :search="searchSymbolPG"
                                  :custom-filter="symbolSearchFilter"
                                  item-key="symbol"
                                  hide-default-footer
                                  hide-default-header
                                  :items-per-page="-1"
                                  :items="
                                  loadingInstruments ? [] : allPriceguardSymbols
                                "
                                  :headers="[{ text: '', value: 'value' }]"
                                  single-select
                              >
                                <template v-slot:no-data>
                                  <v-row justify="center">
                                    <v-col v-if="loadingInstruments" cols="2">
                                      <v-row justify="end">
                                        <v-progress-circular
                                            style="margin-top: -4px"
                                            indeterminate
                                            color="primary"
                                        ></v-progress-circular>
                                      </v-row>
                                    </v-col>
                                    <v-col :cols="loadingInstruments ? 5 : 10">
                                      <p
                                          :style="
                                          loadingInstruments
                                            ? 'text-align: left;'
                                            : 'text-align: center;'
                                        "
                                      >
                                        {{
                                          loadingInstruments
                                              ? "Loading Instruments..."
                                              : serverConnected
                                                  ? "An error has occurred.."
                                                  : "Application is not running"
                                        }}
                                      </p>
                                      <v-btn
                                          v-if="
                                          !serverConnected &&
                                          !loadingInstruments
                                        "
                                          :disabled="!priceGuardModel"
                                          rounded
                                          outlined
                                          color="primary"
                                          style="font-weight: 400"
                                          @click="
                                          $router.push({
                                            path: '/applications',
                                            query: { add: true },
                                          })
                                        "
                                      >Run Applications
                                      </v-btn
                                      >
                                    </v-col>
                                  </v-row>
                                </template>
                                <template v-slot:item="{ item }">
                                  <tr
                                      class="accent"
                                      @click="PGSymbolSelected(item)"
                                  >
                                    <td
                                        :class="
                                        !priceGuardModel
                                          ? 'grey--text'
                                          : 'primary--text'
                                      "
                                        class="py-1"
                                    >
                                      <v-icon
                                          :color="
                                          !priceGuardModel ? 'grey' : 'primary'
                                        "
                                      >
                                        {{
                                          item.checked
                                              ? "radio_button_checked"
                                              : "radio_button_unchecked"
                                        }}
                                      </v-icon>
                                      {{ item.value }}
                                    </td>
                                  </tr>
                                </template>
                              </v-data-table>
                            </v-col>
                          </v-row>
                        </div>

                        <v-row v-if="!add" justify="start" class="mx-0">
                          <v-btn
                              :disabled="
                              !allPriceguardSymbols.length || !priceGuardModel
                            "
                              color="primary"
                              style="font-weight: 400"
                              text
                              @click="selectAllPGSymbols"
                          >Add All
                          </v-btn>
                          <v-btn
                              :disabled="
                              !allPriceguardSymbols.length || !priceGuardModel
                            "
                              color="primary"
                              style="font-weight: 400"
                              text
                              @click="deSelectAllPGSymbols"
                          >Remove All
                          </v-btn>
                          <p class="mb-0 mx-4 pt-2 grey--text subtitle-2">
                            Selected: {{ currentPGSelectedSymbols }}/{{
                              currentPGSymbols
                            }}{{
                              allPriceguardSymbols.length > currentPGSymbols
                                  ? `&nbsp;&nbsp;&nbsp;Total: ${checkedPGSymbolsCount}/${allPriceguardSymbols.length}`
                                  : ""
                            }}
                          </p>
                        </v-row>
                      </v-tab-item>
                      <v-tab-item class="pt-2" style="min-height: 85px">
                        <div style="width: 100%" v-if="add">
                          <v-row justify="center">
                            <v-col cols="10">
                              <p class="mt-7 grey--text text-center">
                                Price Watcher can be configured once created
                              </p>
                            </v-col>
                          </v-row>
                        </div>
                        <div v-if="!add" style="width: 100%">
                          <v-row justify="center">
                            <v-col
                                class="pb-0 pt-0 px-3"
                                style="max-height: 95px; margin-bottom: -1px"
                                cols="12"
                                sm="12"
                            >
                              <v-text-field
                                  :disabled="!priceGuardModel"
                                  v-model="searchSymbolPW"
                                  :value="searchSymbolPW"
                                  outlined
                                  :placeholder="
                                  regexSearchPW ? 'Search with regex' : 'Search'
                                "
                                  single-line
                                  dense
                                  :rules="regexSearchPW ? [rules.validRegex] : []"
                                  :class="
                                  regexSearchPW
                                    ? 'text-field-top-details'
                                    : 'hide-error-message'
                                "
                                  :hide-details="!regexSearchPW"
                                  class="inputSlot-mb-0"
                                  style="z-index: 0"
                              >
                                <template v-slot:append>
                                  <v-row class="mx-0">
                                    <p
                                        class="mb-0 mx-2 pt-1 grey--text subtitle-2"
                                    >
                                      ({{ currentPWSymbols }})
                                    </p>
                                    <v-btn
                                        @click="regexSearchPW = !regexSearchPW"
                                        icon
                                        small
                                        class="mb-2"
                                        :color="
                                        regexSearchPW ? 'primary' : 'white'
                                      "
                                    >
                                      <div
                                          class="absolute"
                                          style="left: 12px; font-size: 17px"
                                      >
                                        *
                                      </div>
                                      <div
                                          class="absolute"
                                          style="
                                          left: 5px;
                                          font-size: 25px;
                                          margin-bottom: 2px;
                                        "
                                      >
                                        .
                                      </div>
                                    </v-btn>
                                  </v-row>
                                </template>
                              </v-text-field>
                            </v-col>
                            <v-col class="pt-0 px-3" cols="12">
                              <v-data-table
                                  @current-items="
                                  (items) => setCurrentPWSymbols(items)
                                "
                                  ref="PWSymbolsTable"
                                  :mobile-breakpoint="0"
                                  id="selectSymbolsTable"
                                  :class="{
                                  'disabled-table': !priceGuardModel,
                                }"
                                  style="
                                  height: 238px;
                                  overflow-y: auto;
                                  border: 1px solid #47bd96;
                                  z-index: 1;
                                "
                                  dense
                                  :search="searchSymbolPW"
                                  :custom-filter="symbolSearchFilter"
                                  item-key="symbol"
                                  hide-default-footer
                                  hide-default-header
                                  :items-per-page="-1"
                                  :items="allPricewatcherSymbols"
                                  :headers="[{ text: '', value: 'value' }]"
                                  single-select
                              >
                                <template v-slot:no-data>
                                  <v-row justify="center">
                                    <v-col v-if="loadingInstruments" cols="2">
                                      <v-row justify="end">
                                        <v-progress-circular
                                            style="margin-top: -4px"
                                            indeterminate
                                            color="primary"
                                        ></v-progress-circular>
                                      </v-row>
                                    </v-col>
                                    <v-col :cols="loadingInstruments ? 5 : 10">
                                      <p
                                          :style="
                                          loadingInstruments
                                            ? 'text-align: left;'
                                            : 'text-align: center;'
                                        "
                                      >
                                        {{
                                          loadingInstruments
                                              ? "Loading Instruments..."
                                              : serverConnected
                                                  ? "An error has occurred.."
                                                  : "Application is not running"
                                        }}
                                      </p>
                                      <v-btn
                                          v-if="
                                          !serverConnected &&
                                          !loadingInstruments
                                        "
                                          :disabled="!priceGuardModel"
                                          rounded
                                          outlined
                                          color="primary"
                                          style="font-weight: 400"
                                          @click="
                                          $router.push({
                                            path: '/applications',
                                            query: { add: true },
                                          })
                                        "
                                      >Run Applications
                                      </v-btn
                                      >
                                    </v-col>
                                  </v-row>
                                </template>
                                <template v-slot:item="{ item }">
                                  <tr
                                      class="accent"
                                      @click="PWSymbolSelected(item)"
                                  >
                                    <td
                                        :class="
                                        !priceGuardModel
                                          ? 'grey--text'
                                          : 'primary--text'
                                      "
                                        class="py-1"
                                    >
                                      <v-icon
                                          :color="
                                          !priceGuardModel ? 'grey' : 'primary'
                                        "
                                      >
                                        {{
                                          item.checked
                                              ? "radio_button_checked"
                                              : "radio_button_unchecked"
                                        }}
                                      </v-icon>
                                      {{ item.value }}
                                    </td>
                                  </tr>
                                </template>
                              </v-data-table>
                            </v-col>
                          </v-row>
                        </div>

                        <v-row v-if="!add" justify="start" class="mx-0">
                          <v-btn
                              :disabled="
                              !allPricewatcherSymbols.length || !priceGuardModel
                            "
                              color="primary"
                              style="font-weight: 400"
                              text
                              @click="selectAllPWSymbols"
                          >Add All
                          </v-btn>
                          <v-btn
                              :disabled="
                              !allPricewatcherSymbols.length || !priceGuardModel
                            "
                              color="primary"
                              style="font-weight: 400"
                              text
                              @click="deSelectAllPWSymbols"
                          >Remove All
                          </v-btn>
                          <p class="mb-0 mx-4 pt-2 grey--text subtitle-2">
                            Selected: {{ currentPWSelectedSymbols }}/{{
                              currentPWSymbols
                            }}{{
                              allPricewatcherSymbols.length > currentPWSymbols
                                  ? `&nbsp;&nbsp;&nbsp;Total: ${checkedPWSymbolsCount}/${allPricewatcherSymbols.length}`
                                  : ""
                            }}
                          </p>
                        </v-row>
                      </v-tab-item>
                    </v-tabs-items>
                  </v-tabs>

                  <v-row
                      v-show="
                      selectedApplicationType === applicationTypeEnums.general
                    "
                      justify="space-between"
                  >
                    <v-col v-if="$vuetify.breakpoint.xsOnly" cols="12">
                      <v-row class="mx-0" justify="center">
                        <p
                            style="color: #47bd96"
                            class="mb-0 mt-2 pr-1 clickableText"
                            @click="analyticsConfigModel = 1"
                        >
                          Advanced Configurations
                        </p>
                        <v-icon
                            @click="analyticsConfigModel = 1"
                            class="mb-0 mt-2 clickableText"
                            style="font-size: 14px; color: #47bd96"
                        >icon-more-23x13
                        </v-icon
                        >
                      </v-row>
                    </v-col>
                    <v-col class="py-2" cols="12" sm="6"></v-col>
                    <v-col v-if="$vuetify.breakpoint.smAndUp" cols="6">
                      <v-row class="mx-0" justify="end">
                        <p
                            style="color: #47bd96"
                            class="mb-0 mt-2 pr-1 clickableText"
                            @click="analyticsConfigModel = 1"
                        >
                          Advanced Configurations
                        </p>
                        <v-icon
                            @click="analyticsConfigModel = 1"
                            class="mb-0 mt-2 pr-2 clickableText"
                            style="font-size: 14px; color: #47bd96"
                        >icon-more-23x13
                        </v-icon
                        >
                      </v-row>
                    </v-col>
                  </v-row>
                </v-tab-item>
                <!-- v-show="
                    selectedApplicationType == applicationTypeEnums.general
                  " -->
                <v-tab-item>
                  <div class="pl-2 pb-4">Common</div>
                  <v-row>
                    <v-tooltip
                        :disabled="isNotDesktop"
                        content-class="tooltipClassBig"
                        bottom
                    >
                      <template v-slot:activator="{ on }">
                        <v-col v-on="on" class="py-0" cols="12" sm="6">
                          <v-text-field
                              class="analyticsTextFieldClass"
                              dense
                              outlined
                              label="Reconnection Time"
                              type="number"
                              v-model.number="ReconnectTimeAN"
                              @keydown="
                              (ev) => setHelperVar(ev, 'ReconnectTimeAN')
                            "
                              @keypress="
                              (ev) => setHelperVar(ev, 'ReconnectTimeAN')
                            "
                              @input="
                              (ev) =>
                                textInput(
                                  ev,
                                  currentDefinition.configuration,
                                  'ReconnectTime'
                                )
                            "
                              @change="clearHelperVar"
                              :rules="[rules.required]"
                          ></v-text-field>
                        </v-col>
                      </template>
                      <span>
                        Time in milliseconds until the service will try to
                        reconnect
                      </span>
                    </v-tooltip>
                    <v-col class="py-0">
                      <v-tooltip
                          :disabled="isNotDesktop"
                          content-class="tooltipClassBig"
                          bottom
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                              class="analyticsTextFieldClass"
                              dense
                              outlined
                              label="Maximum Reconnect Retries"
                              type="number"
                              v-model.number="MaxReconnectRetriesAN"
                              @keydown="
                              (ev) => setHelperVar(ev, 'MaxReconnectRetriesAN')
                            "
                              @keypress="
                              (ev) => setHelperVar(ev, 'MaxReconnectRetriesAN')
                            "
                              @input="
                              (ev) =>
                                textInput(
                                  ev,
                                  currentDefinition.configuration,
                                  'MaxReconnectRetries'
                                )
                            "
                              @change="clearHelperVar"
                              v-on="on"
                              :rules="[rules.required, rules.maxReconnect]"
                          ></v-text-field>
                        </template>
                        <span
                        >Maximum reconnection tries until the routine is
                          stoped</span
                        >
                      </v-tooltip>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6" class="py-0">
                      <v-tooltip
                          :disabled="isNotDesktop"
                          content-class="tooltipClassBig"
                          bottom
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                              class="analyticsTextFieldClass"
                              dense
                              outlined
                              label="Server Name"
                              v-model="currentDefinition.configuration.ServerName"
                              v-on="on"
                          ></v-text-field>
                        </template>
                        <span>
                          A friendly name to identify the data processed by
                          current agent
                          <br/>If not set, the server name will be used on
                          connect
                        </span>
                      </v-tooltip>
                    </v-col>
                    <v-col v-if="isAdmin" cols="12" sm="6" class="py-0">
                      <v-tooltip
                          :disabled="isNotDesktop"
                          content-class="tooltipClassBig"
                          bottom
                      >
                        <template v-slot:activator="{ on }">
                          <div v-on="on">
                            <v-text-field
                                class="analyticsTextFieldClass"
                                dense
                                outlined
                                v-model.number="
                                currentDefinition.configuration
                                  .ConnectionPingCycle
                              "
                                type="number"
                                label="Connection Ping Cycle"
                            ></v-text-field>
                          </div>
                        </template>
                        <span> Intended for internal use only </span>
                      </v-tooltip>
                    </v-col>
                  </v-row>
                  <v-row v-if="isAdmin">
                    <v-col cols="12" sm="6" class="py-0">
                      <v-tooltip
                          :disabled="isNotDesktop"
                          content-class="tooltipClassBig"
                          bottom
                      >
                        <template v-slot:activator="{ on }">
                          <div v-on="on">
                            <v-select
                                outlined
                                dense
                                :menu-props="{ offsetY: true }"
                                item-text="text"
                                v-on="on"
                                label="Compress Messages"
                                v-model="
                                currentDefinition.configuration.CompressMessages
                              "
                                :items="[
                                { value: true, text: 'Yes' },
                                { value: false, text: 'No' },
                              ]"
                            >
                              <template v-slot:item="{ item }">
                                <p class="mb-0">{{ item.text }}</p>
                              </template>
                            </v-select>
                          </div>
                        </template>
                        <span>
                          Determinates if publisher messages will be zipped by
                          the agent
                        </span>
                      </v-tooltip>
                    </v-col>

                    <!-- <v-col v-if="add || edit & currentDefinition.server.version == 'MTT'" cols="12" sm="6" class="py-0"> -->
                    <v-col
                        v-if="
                        (add &&
                          chosenServer &&
                          chosenServer.version === serverVersions.MTT) ||
                        (edit &&
                          currentDefinition.server.version ===
                            serverVersions.MTT)
                      "
                        cols="12"
                        sm="6"
                        class="py-0"
                    >
                      <v-select
                          outlined
                          dense
                          :menu-props="{
                          offsetY: true,
                          maxHeight: '350',
                        }"
                          label="Quote connection"
                          v-model="quoteConnectionModel"
                          :items="availableQuoteConnections"
                          item-color="#262b2e"
                          return-object
                          hide-selected
                      >
                        <template v-slot:item="{}">
                          <div></div>
                        </template>
                        <template v-slot:no-data>
                          <div></div>
                        </template>

                        <template v-slot:append-item>
                          <div
                              class="EodFloatingPnlOffsetTimes-outer pt-2"
                              style="
                              max-height: 348px;
                              border-top: none !important;
                            "
                          >
                            <v-row
                                v-for="connection in quoteConnections"
                                :key="connection.value"
                                class="pa-1 mx-0"
                                style="
                                margin-top: -4px;
                                border-top: none !important;
                                background-color: #262b2e;
                              "
                            >
                              <v-btn
                                  @click="selectQuoteConnection(connection)"
                                  icon
                                  small
                                  :height="24"
                                  :width="24"
                                  class="mt-1"
                              >
                                <v-icon
                                    class="mx-2"
                                    small
                                    :color="
                                    connection.enabled ? 'primary' : 'white'
                                  "
                                >
                                  {{
                                    connection.enabled
                                        ? "fas fa-dot-circle"
                                        : "far fa-dot-circle"
                                  }}
                                </v-icon>
                              </v-btn>
                              <p
                                  @click="selectQuoteConnection(connection)"
                                  :class="{ 'grey--text': !connection.enabled }"
                                  class="pl-2 clickable"
                                  style="width: 160px; padding-top: 4px"
                              >
                                {{ connection.text }}
                              </p>
                              <v-spacer></v-spacer>
                              <v-btn
                                  :disabled="
                                  quoteConnectionSelected.value !==
                                  connection.value
                                "
                                  @click.stop="editQuoteConnection(connection)"
                                  small
                                  icon
                                  class="mr-1 mr-4"
                                  style="margin-top: 1px"
                              >
                                <span
                                    style="font-size: 27px; margin-bottom: 2px"
                                    :class="
                                    quoteConnectionSelected.value !==
                                    connection.value
                                      ? 'icon-edit-21x21-disabled'
                                      : 'icon-edit-21x21'
                                  "
                                >
                                  <span class="path1 letterSpacing0"></span>
                                  <span class="path2"></span>
                                </span>
                              </v-btn>
                            </v-row>
                          </div>
                        </template>

                        <template v-slot:selection="{}">
                          <div class="mr-1">
                            <span>{{ quoteConnectionSelected.text }}</span>
                          </div>
                          <!-- <label
                          v-else
                          class="v-label theme--dark"
                          style="
                            left: 0px;
                            right: auto;
                            position: absolute;
                          "
                          >No times set</label
                        >
                        <span
                          v-if="
                            enabledEodFloatingPnlOffsetTimes.length >
                            1
                          "
                        >
                          (+{{
                            enabledEodFloatingPnlOffsetTimes.length -
                            1
                          }})
                        </span> -->
                        </template>
                      </v-select>
                    </v-col>
                  </v-row>

                  <div v-if="analyticsModel">
                    <div class="pl-2 pb-4">
                      <v-icon
                          class="mr-2 mb-1"
                          style="font-size: 17px; height: 17px; margin-top: 2px"
                      >icon-analytics-23x23
                      </v-icon
                      >
                      Analytics
                    </div>

                    <h2 class="agent-config-category pl-2">Generic</h2>
                    <v-row v-if="isAdmin">
                      <v-col cols="12" sm="6" class="py-0">
                        <v-tooltip
                            :disabled="isNotDesktop"
                            content-class="tooltipClassBig"
                            bottom
                        >
                          <template v-slot:activator="{ on }">
                            <div v-on="on">
                              <v-text-field
                                  class="analyticsTextFieldClass"
                                  dense
                                  outlined
                                  v-model.number="
                                  currentDefinition.configuration.Analytics
                                    .AcceptableDeviationFromUtc
                                "
                                  type="number"
                                  label="Acceptable Deviation From Utc"
                              ></v-text-field>
                            </div>
                          </template>
                          <span>
                            Max acceptable deviation of server time with local
                            time in seconds
                          </span>
                        </v-tooltip>
                      </v-col>
                      <v-col cols="12" sm="6" class="py-0">
                        <v-tooltip
                            :disabled="isNotDesktop"
                            content-class="tooltipClassBig"
                            bottom
                        >
                          <template v-slot:activator="{ on }">
                            <v-select
                                outlined
                                dense
                                :menu-props="{ offsetY: true }"
                                item-text="text"
                                v-on="on"
                                label="Use Journal"
                                v-model="
                                currentDefinition.configuration.Analytics
                                  .UseJournal
                              "
                                :items="[
                                { value: true, text: 'Yes' },
                                { value: false, text: 'No' },
                              ]"
                            >
                              <template v-slot:item="{ item }">
                                <p class="mb-0">{{ item.text }}</p>
                              </template>
                            </v-select>
                          </template>
                          <span>
                            Use journal logs to get data during downtime.<br/>If
                            allowed the permission to use the journal must be
                            granted
                          </span>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6" class="py-0">
                        <v-tooltip
                            :disabled="isNotDesktop"
                            content-class="tooltipClassBig"
                            bottom
                        >
                          <template v-slot:activator="{ on }">
                            <div v-on="on">
                              <v-select
                                  outlined
                                  dense
                                  :menu-props="{ offsetY: true }"
                                  item-text="text"
                                  v-on="on"
                                  :label="`Symbols Multipliers (${currentDefinition.configuration.Analytics.SymbolsMultipliers.length})`"
                                  :items="[]"
                                  :class="{
                                  symbolsMultipliersErrorStyle:
                                    !multipliersForm,
                                }"
                              >
                                <template v-slot:no-data>
                                  <div></div>
                                </template>
                                <template v-slot:append-item>
                                  <div
                                      style="
                                      max-height: 209px;
                                      border-top: none !important;
                                    "
                                  >
                                    <v-form
                                        ref="multipliersAddingForm"
                                        v-model="multipliersAddingForm"
                                    >
                                      <v-row
                                          class="mx-1 mt-1 mb-0"
                                          style="border-top: none !important"
                                      >
                                        <v-text-field
                                            v-model="multipliersSymbol"
                                            class="mini-text-field mr-1"
                                            style="width: 100px !important"
                                            outlined
                                            dense
                                            label="Symbol"
                                            :rules="[rules.required]"
                                        ></v-text-field>
                                        <v-text-field
                                            v-model.number="multiplier"
                                            type="number"
                                            class="mini-text-field mx-1"
                                            style="
                                            width: 100px !important;
                                            border-top: none !important;
                                          "
                                            outlined
                                            dense
                                            label="Multiplier"
                                            :rules="[rules.required]"
                                        ></v-text-field>
                                        <v-btn
                                            @click="
                                            $refs.multipliersAddingForm.validate()
                                              ? addCurMultiplier()
                                              : 0
                                          "
                                            small
                                            class="primary"
                                            style="margin-top: 1px"
                                        >Add
                                        </v-btn
                                        >
                                      </v-row>
                                    </v-form>
                                    <p
                                        v-if="
                                        currentDefinition.configuration &&
                                        currentDefinition.configuration
                                          .Analytics.SymbolsMultipliers.length
                                      "
                                        class="ml-1 mb-1 py-0"
                                        style="margin-top: -8px; font-size: 14px"
                                    >
                                      List ({{
                                        currentDefinition.configuration
                                            .Analytics.SymbolsMultipliers.length
                                      }}):
                                    </p>
                                    <v-form
                                        ref="multipliersForm"
                                        v-model="multipliersForm"
                                    >
                                      <v-row
                                          v-for="multiplier in currentDefinition
                                          .configuration.Analytics
                                          .SymbolsMultipliers"
                                          :key="multiplier.id"
                                          class="pa-1 mx-0"
                                          style="
                                          margin-top: -4px;
                                          border-top: none !important;
                                          background-color: #262b2e;
                                        "
                                      >
                                        <v-text-field
                                            v-model="multiplier.details[0]"
                                            class="mini-text-field mr-1"
                                            style="width: 100px !important"
                                            outlined
                                            dense
                                            label="Symbol"
                                            :rules="[rules.required]"
                                        ></v-text-field>
                                        <v-text-field
                                            v-model.number="multiplier.details[1]"
                                            type="number"
                                            class="mini-text-field mx-1"
                                            style="
                                            width: 100px !important;
                                            border-top: none !important;
                                          "
                                            outlined
                                            dense
                                            label="Multiplier"
                                            :rules="[rules.required]"
                                        ></v-text-field>
                                        <v-tooltip
                                            :disabled="isNotDesktop"
                                            content-class="tooltipClassBig"
                                            bottom
                                        >
                                          <template v-slot:activator="{ on }">
                                            <v-btn
                                                v-on="on"
                                                @click="
                                                deleteMultiplier(multiplier.id)
                                              "
                                                small
                                                style="margin-top: 1px"
                                                icon
                                            >
                                              <span
                                                  class="icon-delete-21x21"
                                                  style="
                                                  font-size: 27px;
                                                  margin-bottom: 2px;
                                                "
                                              >
                                                <span
                                                    class="path1 letterSpacing0"
                                                ></span>
                                                <span class="path2"></span>
                                              </span>
                                            </v-btn>
                                          </template>
                                          <span> Delete </span>
                                        </v-tooltip>
                                      </v-row>
                                    </v-form>
                                  </div>
                                </template>
                                <template v-slot:item="{ item }">
                                  <p class="mb-0">{{ item.text }}</p>
                                </template>
                              </v-select>
                            </div>
                          </template>
                          <span>
                            Set custom multipliers for symbols that reference
                            subdivisions<br/>of a currency (eg cents instead of
                            GBP)
                          </span>
                        </v-tooltip>
                      </v-col>
                      <v-col v-if="isAdmin" cols="12" sm="6" class="py-0">
                        <v-tooltip
                            :disabled="isNotDesktop"
                            content-class="tooltipClassBig"
                            bottom
                        >
                          <template v-slot:activator="{ on }">
                            <div v-on="on">
                              <v-text-field
                                  class="analyticsTextFieldClass"
                                  dense
                                  outlined
                                  v-model.number="
                                  currentDefinition.configuration.Analytics
                                    .CalculationCurrencyDigits
                                "
                                  type="number"
                                  label="Calculation Currency Digits"
                              ></v-text-field>
                            </div>
                          </template>
                          <span> Digits for CalculationCurrency </span>
                        </v-tooltip>
                      </v-col>
                    </v-row>

                    <h2 class="agent-config-category pl-2">Users</h2>
                    <v-row>
                      <v-col cols="12" sm="6" class="py-0">
                        <v-tooltip
                            :disabled="isNotDesktop"
                            content-class="tooltipClassBig"
                            bottom
                        >
                          <template v-slot:activator="{ on }">
                            <div v-on="on">
                              <v-select
                                  outlined
                                  dense
                                  :menu-props="{ offsetY: true }"
                                  item-text="text"
                                  v-on="on"
                                  label="Extract Personal Information"
                                  v-model="
                                  currentDefinition.configuration.Analytics
                                    .PrivacyPolicyAccepted
                                "
                                  :items="[
                                  { value: true, text: 'Accepted' },
                                  { value: false, text: 'Not Accepted' },
                                ]"
                              >
                                <template v-slot:item="{ item }">
                                  <p class="mb-0">{{ item.text }}</p>
                                </template>
                              </v-select>
                            </div>
                          </template>
                          <span>
                            Understand and comply with the terms & conditions of
                            the privacy policy
                          </span>
                        </v-tooltip>
                      </v-col>
                      <v-col cols="12" sm="6" class="py-0">
                        <v-tooltip
                            :disabled="isNotDesktop"
                            content-class="tooltipClassBig"
                            bottom
                        >
                          <template v-slot:activator="{ on }">
                            <div v-on="on">
                              <v-text-field
                                  class="analyticsTextFieldClass"
                                  dense
                                  outlined
                                  label="User Synchronization Cycle"
                                  v-model.number="UserSynchronizationCycleAN"
                                  @keydown="
                                  (ev) =>
                                    setHelperVar(
                                      ev,
                                      'UserSynchronizationCycleAN'
                                    )
                                "
                                  @keypress="
                                  (ev) =>
                                    setHelperVar(
                                      ev,
                                      'UserSynchronizationCycleAN'
                                    )
                                "
                                  @input="
                                  (ev) =>
                                    textInput(
                                      ev,
                                      currentDefinition.configuration,
                                      'UserSynchronizationCycle'
                                    )
                                "
                                  @focusout="clearHelperVar"
                                  type="number"
                                  :rules="[rules.required]"
                              ></v-text-field>
                            </div>
                          </template>
                          <span>
                            Period of time in seconds to store a snapshot of
                            users in database
                          </span>
                        </v-tooltip>
                      </v-col>

                      <v-col cols="12" sm="6" class="py-0">
                        <v-tooltip
                            :disabled="isNotDesktop"
                            content-class="tooltipClassBig"
                            bottom
                        >
                          <template v-slot:activator="{ on }">
                            <div v-on="on">
                              <v-text-field
                                  class="analyticsTextFieldClass"
                                  dense
                                  outlined
                                  label="User ID Extraction Regex"
                                  v-model="
                                  currentDefinition.configuration.Analytics
                                    .UserIdExtractRegex
                                "
                              ></v-text-field>
                            </div>
                          </template>
                          <span>
                            The regular expression which will be used to extract
                            the actual ID from the User ID field
                          </span>
                        </v-tooltip>
                      </v-col>

                      <v-col v-if="isAdmin" cols="12" sm="6" class="py-0">
                        <v-tooltip
                            :disabled="isNotDesktop"
                            content-class="tooltipClassBig"
                            bottom
                        >
                          <template v-slot:activator="{ on }">
                            <div v-on="on">
                              <v-select
                                  outlined
                                  dense
                                  :menu-props="{ offsetY: true }"
                                  item-text="text"
                                  v-on="on"
                                  label="Delete Old Users From The Database"
                                  v-model="
                                  currentDefinition.configuration.Analytics
                                    .DeleteOldUsersFromDb
                                "
                                  :items="[
                                  { value: true, text: 'Yes' },
                                  { value: false, text: 'No' },
                                ]"
                              >
                                <template v-slot:item="{ item }">
                                  <p class="mb-0">{{ item.text }}</p>
                                </template>
                              </v-select>
                            </div>
                          </template>
                          <span>
                            If true old users will be deleted form the<br/>database
                            on next users persist cycle
                          </span>
                        </v-tooltip>
                      </v-col>

                      <v-col v-if="isAdmin" cols="12" sm="6" class="py-0">
                        <v-tooltip
                            :disabled="isNotDesktop"
                            content-class="tooltipClassBig"
                            bottom
                        >
                          <template v-slot:activator="{ on }">
                            <v-select
                                outlined
                                dense
                                :menu-props="{ offsetY: true }"
                                item-text="text"
                                v-on="on"
                                label="Ignore Unmodified Users"
                                v-model="
                                currentDefinition.configuration.Analytics
                                  .IgnoreUnmodifiedUsers
                              "
                                :items="[
                                { value: true, text: 'Yes' },
                                { value: false, text: 'No' },
                              ]"
                            >
                              <template v-slot:item="{ item }">
                                <p class="mb-0">{{ item.text }}</p>
                              </template>
                            </v-select>
                          </template>
                          <span>
                            Indicates where to skip saving users to the db that
                            where not modified since last cycle
                          </span>
                        </v-tooltip>
                      </v-col>

                      <v-col v-if="isAdmin" cols="12" sm="6" class="py-0">
                        <v-tooltip
                            :disabled="isNotDesktop"
                            content-class="tooltipClassBig"
                            bottom
                        >
                          <template v-slot:activator="{ on }">
                            <div v-on="on">
                              <v-text-field
                                  class="analyticsTextFieldClass"
                                  dense
                                  outlined
                                  label="Users Prepared Statement Limit"
                                  type="number"
                                  v-model.number="
                                  currentDefinition.configuration.Analytics
                                    .UsersPreparedStatementLimit
                                "
                              ></v-text-field>
                            </div>
                          </template>
                          <span>
                            Deciding factor when to use prepared statement or
                            copy for users persistence.
                          </span>
                        </v-tooltip>
                      </v-col>
                    </v-row>

                    <h2 class="agent-config-category pl-2">Daily Reports</h2>
                    <v-row>
                      <v-col cols="12" sm="6" class="py-0">
                        <v-tooltip
                            :disabled="isNotDesktop"
                            content-class="tooltipClassBig"
                            bottom
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                                class="analyticsTextFieldClass"
                                dense
                                outlined
                                label="Daily reports fetch offset time"
                                type="number"
                                v-model.number="DailyReportsFetchOffsetTime"
                                @keydown="
                                (ev) =>
                                  setHelperVar(
                                    ev,
                                    'DailyReportsFetchOffsetTime'
                                  )
                              "
                                @keypress="
                                (ev) =>
                                  setHelperVar(
                                    ev,
                                    'DailyReportsFetchOffsetTime'
                                  )
                              "
                                @input="
                                (ev) =>
                                  textInput(
                                    ev,
                                    currentDefinition.configuration,
                                    'DailyReportsFetchOffsetTime'
                                  )
                              "
                                @focusout="clearHelperVar"
                                v-on="on"
                                :rules="[rules.required]"
                            ></v-text-field>
                          </template>
                          <span>
                            Duration in minutes to delay fetch daily reports
                            from
                            <br/>server, this useful for slow servers that take
                            <br/>time to complete roll over operations.
                          </span>
                        </v-tooltip>
                      </v-col>
                      <v-col cols="12" sm="6" class="py-0">
                        <v-tooltip
                            :disabled="isNotDesktop"
                            content-class="tooltipClassBig"
                            bottom
                        >
                          <template v-slot:activator="{ on }">
                            <div v-on="on">
                              <v-text-field
                                  class="analyticsTextFieldClass"
                                  dense
                                  outlined
                                  v-model="
                                  currentDefinition.configuration.Analytics
                                    .DailyProfitSynchronizationCycle
                                "
                                  label="Daily Profit Synchronization Cycle"
                              ></v-text-field>
                            </div>
                          </template>
                          <span>
                            Time interval to check and fetch daily reports in
                            seconds
                          </span>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6" class="py-0">
                        <v-tooltip
                            :disabled="isNotDesktop"
                            content-class="tooltipClassBig"
                            bottom
                        >
                          <template v-slot:activator="{ on }">
                            <div v-on="on">
                              <v-text-field
                                  class="analyticsTextFieldClass"
                                  dense
                                  outlined
                                  label="Default Prefetch Daily Reports"
                                  type="number"
                                  v-model.number="
                                  currentDefinition.configuration.Analytics
                                    .DefaultPrefetchDailyReports
                                "
                                  @keydown="
                                  (ev) =>
                                    setHelperVar(
                                      ev,
                                      'DefaultPrefetchDailyReports'
                                    )
                                "
                                  @keypress="
                                  (ev) =>
                                    setHelperVar(
                                      ev,
                                      'DefaultPrefetchDailyReports'
                                    )
                                "
                                  @input="
                                  (ev) =>
                                    textInput(
                                      ev,
                                      currentDefinition.configuration,
                                      'TradesLingerTime'
                                    )
                                "
                                  @focusout="clearHelperVar"
                                  :rules="[rules.required]"
                              ></v-text-field>
                            </div>
                          </template>
                          <span>
                            Default number of daily reports to fetch if none
                            exists in the database
                          </span>
                        </v-tooltip>
                      </v-col>
                      <v-col cols="12" sm="6" class="py-0">
                        <v-tooltip
                            :disabled="isNotDesktop"
                            content-class="tooltipClassBig"
                            bottom
                        >
                          <template v-slot:activator="{ on }">
                            <div v-on="on">
                              <v-select
                                  outlined
                                  dense
                                  :menu-props="{ offsetY: true }"
                                  item-text="text"
                                  v-on="on"
                                  label="Ignore Empty Daily Reports"
                                  v-model="
                                  currentDefinition.configuration.Analytics
                                    .IgnoreEmptyDailyReports
                                "
                                  :items="[
                                  { value: true, text: 'Ignore' },
                                  { value: false, text: 'Don\'t ignore' },
                                ]"
                              >
                                <template v-slot:item="{ item }">
                                  <p class="mb-0">{{ item.text }}</p>
                                </template>
                              </v-select>
                            </div>
                          </template>
                          <span>
                            Ignore storing daily profits for accounts where
                            equity/floating or settle pnl is 0
                          </span>
                        </v-tooltip>
                      </v-col>
                    </v-row>

                    <h2 v-if="isAdmin" class="agent-config-category pl-2">
                      Journal
                    </h2>
                    <v-row v-if="isAdmin">
                      <v-col class="py-0" cols="12" sm="6">
                        <v-tooltip
                            :disabled="isNotDesktop"
                            content-class="tooltipClass"
                            bottom
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                                v-model.number="DefaultPrefetchJournal"
                                :rules="[rules.required]"
                                v-on="on"
                                class="analyticsTextFieldClass"
                                dense
                                outlined
                                label="Default Prefetch Journal"
                                type="number"
                            ></v-text-field>
                          </template>
                          <span>
                            How many days of journal logs to fetch on the first
                            run.
                          </span>
                        </v-tooltip>
                      </v-col>
                      <v-col class="py-0" cols="12" sm="6">
                        <v-tooltip
                            :disabled="isNotDesktop"
                            content-class="tooltipClass"
                            bottom
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                                v-model.number="JournalFetchOffsetTime"
                                :rules="[rules.required]"
                                v-on="on"
                                class="analyticsTextFieldClass"
                                dense
                                outlined
                                label="Journal Fetch Offset Time"
                                type="number"
                            ></v-text-field>
                          </template>
                          <span>
                            Delay the duration of journal requests by minutes
                            starting from midnight.
                          </span>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                    <v-row v-if="isAdmin">
                      <v-col cols="12" sm="6" class="py-0">
                        <v-tooltip
                            :disabled="isNotDesktop"
                            content-class="tooltipClassBig"
                            bottom
                        >
                          <template v-slot:activator="{ on }">
                            <div v-on="on">
                              <v-select
                                  v-model="JournalFiltersModel"
                                  :items="['Filters']"
                                  outlined
                                  dense
                                  :menu-props="{
                                  offsetY: true,
                                  closeOnClick: false,
                                  closeOnContentClick: false,
                                }"
                                  item-text="text"
                                  label="Journal Filters"
                                  hide-selected
                              >
                                <template v-slot:item="{}">
                                  <div
                                      style="border-top: none !important"
                                  ></div>
                                </template>
                                <template v-slot:no-data
                                >
                                  <div
                                      style="border-top: none !important"
                                  ></div
                                  >
                                </template>
                                <template v-slot:prepend-item>
                                  <v-list-item
                                      @click="addJournalFilter"
                                      style="
                                      max-height: 40px;
                                      border-bottom: 1px solid #7f7f7f;
                                    "
                                      ripple
                                  >
                                    <v-list-item-content>
                                      <v-list-item-title
                                          style="
                                          font-size: 14px !important;
                                          font-weight: 400;
                                        "
                                      >
                                        <i
                                            style="color: #47bd96"
                                            class="fas fa-plus-circle mr-1"
                                        ></i>
                                        Add filter
                                      </v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                </template>
                                <template v-slot:append-item>
                                  <div
                                      style="
                                      max-height: 209px;
                                      border-top: none !important;
                                    "
                                  >
                                    <v-row
                                        v-for="filter in currentDefinition
                                        .configuration.Analytics.JournalFilters"
                                        :key="filter.id"
                                        class="mx-4 mb-0"
                                        style="
                                        border-top: none !important;
                                        height: 40px;
                                      "
                                    >
                                      <p class="pt-2 mb-0">
                                        {{ filter.Name }}
                                      </p>
                                      <v-spacer></v-spacer>
                                      <v-tooltip
                                          :disabled="isNotDesktop"
                                          bottom
                                      >
                                        <template v-slot:activator="{ on }">
                                          <v-btn
                                              v-on="on"
                                              @click="editJournalFilter(filter)"
                                              small
                                              icon
                                              class="pt-2 mr-1"
                                              style="margin-top: 1px"
                                          >
                                            <span
                                                style="
                                                font-size: 27px;
                                                margin-bottom: 2px;
                                              "
                                                class="icon-edit-21x21"
                                            >
                                              <span
                                                  class="path1 letterSpacing0"
                                              ></span>
                                              <span class="path2"></span>
                                            </span>
                                          </v-btn>
                                        </template>
                                        <span> Edit </span>
                                      </v-tooltip>
                                      <v-tooltip
                                          :disabled="isNotDesktop"
                                          bottom
                                      >
                                        <template v-slot:activator="{ on }">
                                          <v-btn
                                              v-on="on"
                                              @click="deleteJournalFilter(filter)"
                                              small
                                              style="margin-top: 1px"
                                              class="pt-2"
                                              icon
                                          >
                                            <span
                                                class="icon-delete-21x21"
                                                style="
                                                font-size: 27px;
                                                margin-bottom: 2px;
                                              "
                                            >
                                              <span
                                                  class="path1 letterSpacing0"
                                              ></span>
                                              <span class="path2"></span>
                                            </span>
                                          </v-btn>
                                        </template>
                                        <span> Delete </span>
                                      </v-tooltip>
                                    </v-row>
                                  </div>
                                </template>
                                <template v-slot:selection="{}">
                                  <div
                                      v-if="
                                      currentDefinition.configuration.Analytics
                                        .JournalFilters.length
                                    "
                                      class="mr-1"
                                  >
                                    <span>{{
                                        currentDefinition.configuration.Analytics
                                            .JournalFilters[0].Name
                                      }}</span>
                                  </div>
                                  <label
                                      v-else
                                      class="v-label theme--dark"
                                      style="
                                      left: 0;
                                      right: auto;
                                      position: absolute;
                                    "
                                  >No Journal Filters</label
                                  >
                                  <span
                                      v-if="
                                      currentDefinition.configuration.Analytics
                                        .JournalFilters.length > 1
                                    "
                                  >
                                    (+{{
                                      currentDefinition.configuration.Analytics
                                          .JournalFilters.length - 1
                                    }})
                                  </span>
                                </template>
                              </v-select>
                            </div>
                          </template>
                          <span> Journal filter configuration </span>
                        </v-tooltip>
                      </v-col>
                      <v-col class="py-0" cols="12" sm="6">
                        <v-tooltip
                            :disabled="isNotDesktop"
                            content-class="tooltipClass"
                            bottom
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                                v-model.number="JournalSynchronizationCycle"
                                :rules="[rules.required]"
                                v-on="on"
                                class="analyticsTextFieldClass"
                                dense
                                outlined
                                label="Journal Synchronization Cycle"
                                type="number"
                            ></v-text-field>
                          </template>
                          <span>
                            Time interval to check and persist (if needed)<br/>journal
                            record to db in seconds.
                          </span>
                        </v-tooltip>
                      </v-col>
                    </v-row>

                    <h2 v-if="isAdmin" class="agent-config-category pl-2">
                      Hedge
                    </h2>
                    <v-row v-if="isAdmin">
                      <v-col cols="12" sm="6" class="py-0">
                        <v-tooltip
                            :disabled="isNotDesktop"
                            content-class="tooltipClass"
                            bottom
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                                v-model.number="AiHedgeIntelSynchronizationCycle"
                                :default="60"
                                v-on="on"
                                class="analyticsTextFieldClass"
                                dense
                                outlined
                                label="Hedge Intel Synchronization Cycle"
                                type="number"
                            ></v-text-field>
                          </template>
                          <span>
                            Synchronization cycle (in seconds) for dispatching
                            hedge information to ai component.
                          </span>
                        </v-tooltip>
                      </v-col>
                      <v-col cols="12" sm="6" class="py-0">
                        <v-tooltip
                            :disabled="isNotDesktop"
                            content-class="tooltipClass"
                            bottom
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                                v-model.trim="HedgeBookRegex"
                                default="(?<book>(^A(?<percentage>(\d+)?))|^B)-Book"
                                v-on="on"
                                class="analyticsTextFieldClass"
                                dense
                                outlined
                                label="Validation regex"
                                type="text"
                            ></v-text-field>
                          </template>
                          <div style="text-align: left;">
                            <span>
                              Regex in order to validate (and replace) hedge information.
                              <br/>
                              Only the book entries that pass this regex are included in the hedge information.
                              <br/>
                              <br/>
                              <strong><i>Make sure to always keep the book and percentage named capture groups since <br/>those are used internally in order to format book in a relevant (to the ai) way</i></strong>
                            </span>
                          </div>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                    <h2 v-if="isAdmin" class="agent-config-category pl-2">
                      EodFloatingPnl
                    </h2>
                    <v-row v-if="isAdmin">
                      <v-col cols="12" sm="6" class="py-0">
                        <v-tooltip
                            :disabled="isNotDesktop"
                            content-class="tooltipClassBig"
                            bottom
                        >
                          <template v-slot:activator="{ on }">
                            <div v-on="on">
                              <v-select
                                  outlined
                                  dense
                                  :menu-props="{
                                  offsetY: true,
                                  maxHeight: '350',
                                }"
                                  v-on="on"
                                  label="EOD Floating Pnl Offset Times"
                                  v-model="eodFloatingPnlOffsetTimesModel"
                                  :items="['Days']"
                                  item-text="day"
                                  item-value="day"
                                  item-color="#262b2e"
                                  return-object
                                  hide-selected
                              >
                                <template v-slot:item="{}">
                                  <div></div>
                                </template>

                                <template v-slot:selection="{}">
                                  <div
                                      v-if="
                                      enabledEodFloatingPnlOffsetTimes.length
                                    "
                                      class="mr-1"
                                  >
                                    <span>{{
                                        enabledEodFloatingPnlOffsetTimes[0]
                                            .dayName
                                      }}</span>
                                  </div>
                                  <label
                                      v-else
                                      class="v-label theme--dark"
                                      style="
                                      left: 0;
                                      right: auto;
                                      position: absolute;
                                    "
                                  >No times set</label
                                  >
                                  <span
                                      v-if="
                                      enabledEodFloatingPnlOffsetTimes.length >
                                      1
                                    "
                                  >
                                    (+{{
                                      enabledEodFloatingPnlOffsetTimes.length -
                                      1
                                    }})
                                  </span>
                                </template>

                                <template v-slot:append-item>
                                  <div
                                      class="EodFloatingPnlOffsetTimes-outer pt-2"
                                      style="
                                      max-height: 348px;
                                      border-top: none !important;
                                    "
                                  >
                                    <v-row
                                        v-for="day in currentDefinition
                                        .configuration.Analytics
                                        .EodFloatingPnlOffsetTimes"
                                        :key="day.dayName"
                                        class="pa-1 mx-0"
                                        style="
                                        margin-top: -4px;
                                        border-top: none !important;
                                        background-color: #262b2e;
                                      "
                                    >
                                      <!-- @click="day.enabled = !day.enabled;eodOffsetDaySelected();" -->
                                      <v-btn
                                          @click="day.enabled = !day.enabled"
                                          icon
                                          small
                                          :height="24"
                                          :width="24"
                                          class="mt-1"
                                      >
                                        <v-icon
                                            class="mx-2"
                                            small
                                            :color="
                                            day.enabled ? 'primary' : 'white'
                                          "
                                        >
                                          {{
                                            day.enabled
                                                ? "fas fa-dot-circle"
                                                : "far fa-dot-circle"
                                          }}
                                        </v-icon>
                                      </v-btn>
                                      <p
                                          @click="day.enabled = !day.enabled"
                                          :class="{ 'grey--text': !day.enabled }"
                                          class="pl-2 clickable"
                                          style="width: 80px; padding-top: 4px"
                                      >
                                        {{ day.dayName }}
                                      </p>
                                      <v-spacer></v-spacer>
                                      <v-text-field
                                          v-model.number="day.From"
                                          :disabled="!day.enabled"
                                          type="number"
                                          class="mini-text-field mr-1"
                                          style="width: 74px !important"
                                          outlined
                                          dense
                                          label="From (s)"
                                      ></v-text-field>
                                      <v-text-field
                                          v-model.number="day.To"
                                          :disabled="!day.enabled"
                                          type="number"
                                          class="mini-text-field mx-1"
                                          style="
                                          width: 74px !important;
                                          border-top: none !important;
                                        "
                                          outlined
                                          dense
                                          label="To (s)"
                                      ></v-text-field>
                                    </v-row>
                                  </div>
                                </template>
                                <template v-slot:no-data>
                                  <div></div>
                                </template>
                              </v-select>
                            </div>
                          </template>
                          <span>
                            Start and end times per day of week for populating
                            eod floating pnl per day. Times are in seconds
                            starting from server midnight.
                          </span>
                        </v-tooltip>
                      </v-col>
                      <v-col class="py-0" cols="12" sm="6">
                        <v-tooltip
                            :disabled="isNotDesktop"
                            content-class="tooltipClassBig"
                            bottom
                        >
                          <template v-slot:activator="{ on }">
                            <div v-on="on">
                              <v-select
                                  outlined
                                  dense
                                  :menu-props="{ offsetY: true }"
                                  item-text="text"
                                  v-on="on"
                                  label="Group Eod Floating Pnls"
                                  v-model="
                                  currentDefinition.configuration.Analytics
                                    .GroupEodFloatingPnls
                                "
                                  :items="[
                                  { value: true, text: 'Yes' },
                                  { value: false, text: 'No' },
                                ]"
                              >
                                <template v-slot:item="{ item }">
                                  <p class="mb-0">{{ item.text }}</p>
                                </template>
                              </v-select>
                            </div>
                          </template>
                          <span>
                            Group summary items by symbol or batch them as raw
                            records.
                          </span>
                        </v-tooltip>
                      </v-col>
                    </v-row>

                    <h2 class="agent-config-category pl-2">Exclusions</h2>

                    <v-row>
                      <v-col cols="12" sm="6" class="py-0">
                        <v-tooltip
                            :disabled="isNotDesktop"
                            content-class="tooltipClassBig"
                            bottom
                        >
                          <template v-slot:activator="{ on }">
                            <div v-on="on">
                              <v-textarea
                                  outlined
                                  v-model="
                                  currentDefinition.configuration.Analytics
                                    .ExcludeLogins
                                "
                                  role="textbox"
                                  label="Logins to exclude (e.g 3,4,15)"
                                  dense
                                  class="dense-textarea"
                                  :min-height="30"
                              >
                              </v-textarea>
                            </div>
                          </template>
                          <span>
                            The regular expression which will be used to extract
                            the actual ID from the User ID field
                          </span>
                        </v-tooltip>
                      </v-col>
                      <v-col v-if="isAdmin" cols="12" sm="6" class="py-0">
                        <v-tooltip
                            :disabled="isNotDesktop"
                            content-class="tooltipClassBig"
                            bottom
                        >
                          <template v-slot:activator="{ on }">
                            <div v-on="on">
                              <v-text-field
                                  class="analyticsTextFieldClass"
                                  dense
                                  outlined
                                  v-model="
                                  currentDefinition.configuration.Analytics
                                    .ExcludeServices
                                "
                                  label="Exclude Services"
                              ></v-text-field>
                            </div>
                          </template>
                          <span>
                            Excludes certain synchronizers and/or schedulers<br/>from
                            starting (only valid on application start)
                          </span>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col v-if="isAdmin" cols="12" sm="6" class="py-0">
                        <v-tooltip
                            :disabled="isNotDesktop"
                            content-class="tooltipClassBig"
                            bottom
                        >
                          <template v-slot:activator="{ on }">
                            <div v-on="on">
                              <v-textarea
                                  outlined
                                  v-model="
                                  currentDefinition.configuration.Analytics
                                    .CustomUserExclusion
                                "
                                  role="textbox"
                                  label="Custom User Exclusion"
                                  dense
                                  class="dense-textarea"
                                  :min-height="30"
                              >
                              </v-textarea>
                            </div>
                          </template>
                          <span>
                            A custom lambda expression used exclude specific
                            users.
                          </span>
                        </v-tooltip>
                      </v-col>
                    </v-row>

                    <h2 class="agent-config-category pl-2">Ticks</h2>

                    <v-row>
                      <v-col cols="12" sm="6" class="py-0">
                        <v-tooltip
                            :disabled="isNotDesktop"
                            content-class="tooltipClassBig"
                            bottom
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                                v-on="on"
                                class="analyticsTextFieldClass"
                                dense
                                outlined
                                label="Ticks Synchronization Cycle"
                                type="number"
                                v-model.number="TicksSynchronizationCycleAN"
                                @keydown="
                                (ev) =>
                                  setHelperVar(
                                    ev,
                                    'TicksSynchronizationCycleAN'
                                  )
                              "
                                @keypress="
                                (ev) =>
                                  setHelperVar(
                                    ev,
                                    'TicksSynchronizationCycleAN'
                                  )
                              "
                                @input="
                                (ev) =>
                                  textInput(
                                    ev,
                                    currentDefinition.configuration,
                                    'TicksSynchronizationCycle'
                                  )
                              "
                                @change="clearHelperVar"
                                :rules="[rules.required]"
                            ></v-text-field>
                          </template>
                          <span>
                            Period of time in milliseconds to store a snapshot
                            of ticks in database
                          </span>
                        </v-tooltip>
                      </v-col>

                      <v-col v-if="isAdmin" cols="12" sm="6" class="py-0">
                        <v-tooltip
                            :disabled="isNotDesktop"
                            content-class="tooltipClassBig"
                            bottom
                        >
                          <template v-slot:activator="{ on }">
                            <div v-on="on">
                              <v-text-field
                                  class="analyticsTextFieldClass"
                                  dense
                                  outlined
                                  v-model.number="
                                  currentDefinition.configuration.Analytics
                                    .LiveTicksSynchronizationCycle
                                "
                                  type="number"
                                  label="Live Ticks Synchronization Cycle"
                              ></v-text-field>
                            </div>
                          </template>
                          <span>
                            Synchronization cycle for live ticks in ms
                          </span>
                        </v-tooltip>
                      </v-col>

                      <v-col v-if="isAdmin" cols="12" sm="6" class="py-0">
                        <v-tooltip
                            :disabled="isNotDesktop"
                            content-class="tooltipClassBig"
                            bottom
                        >
                          <template v-slot:activator="{ on }">
                            <div v-on="on">
                              <v-text-field
                                  class="analyticsTextFieldClass"
                                  dense
                                  outlined
                                  v-model="
                                  currentDefinition.configuration.Analytics
                                    .SecondaryCalculationCurrencies
                                "
                                  type="string"
                                  label="Additional calculation currencies"
                                  persistent-placeholder
                              ></v-text-field>
                            </div>
                          </template>
                          <span>
                            Additional calculation currencies that the agent should take into account when crafting live ticks
                          </span>
                        </v-tooltip>
                      </v-col>

                      <v-col v-if="isAdmin" cols="12" sm="6" class="py-0">
                        <v-tooltip
                            :disabled="isNotDesktop"
                            content-class="tooltipClassBig"
                            bottom
                        >
                          <template v-slot:activator="{ on }">
                            <div v-on="on">
                              <v-text-field
                                  class="analyticsTextFieldClass"
                                  dense
                                  outlined
                                  v-model="
                                  currentDefinition.configuration.Analytics
                                    .CalculationCurrenciesSuffixes
                                "
                                  type="string"
                                  label="Calculation currencies suffixes"
                                  persistent-placeholder
                              ></v-text-field>
                            </div>
                          </template>
                          <span>
                            Suffixes to use when crafting live ticks (e.g. .std) when the actual symbol is not available (e.g. EURUSD does not exist but EURUSD.std does. Note the produced live ticks will not use suffix. It's used to prioritize conversion. Order matters)
                          </span>
                        </v-tooltip>
                      </v-col>

                      <v-col v-if="isAdmin" cols="12" sm="6" class="py-0">
                        <v-tooltip
                            :disabled="isNotDesktop"
                            content-class="tooltipClassBig"
                            bottom
                        >
                          <template v-slot:activator="{ on }">
                            <div v-on="on">
                              <v-text-field
                                  class="analyticsTextFieldClass"
                                  dense
                                  outlined
                                  v-model="
                                  currentDefinition.configuration.Analytics.IntermediateCurrencies
                                "
                                  type="string"
                                  label="Default intermediate currency"
                                  persistent-placeholder
                              ></v-text-field>
                            </div>
                          </template>
                          <span>
                            Default intermediate currency used in order to craft prices for missing symbols (needed for conversions). By default MT4 and MT5 platforms use USD
                          </span>
                        </v-tooltip>
                      </v-col>

                      <v-col v-if="isAdmin" cols="12" sm="6" class="py-0">
                        <v-tooltip
                            :disabled="isNotDesktop"
                            content-class="tooltipClassBig"
                            bottom
                        >
                          <template v-slot:activator="{ on }">
                            <div v-on="on">
                              <v-text-field
                                  class="analyticsTextFieldClass"
                                  dense
                                  outlined
                                  v-model.number="
                                  currentDefinition.configuration.Analytics.MissingSymbolsToLiveTicksSynchronizationCycleRatio
                                "
                                  type="number"
                                  label="Missing Symbols live ticks synchronization cycles"
                                  persistent-placeholder
                              ></v-text-field>
                            </div>
                          </template>
                          <span>
                            How many live ticks synchronization cycles are needed in order to craft live ticks for missing symbols (needed for conversions)
                          </span>
                        </v-tooltip>
                      </v-col>
                    </v-row>

                    <h2 class="agent-config-category pl-2">Positions</h2>
                    <v-row v-if="isAdmin">
                      <v-col cols="12" sm="6" class="py-0">
                        <v-tooltip
                            :disabled="isNotDesktop"
                            content-class="tooltipClassBig"
                            bottom
                        >
                          <template v-slot:activator="{ on }">
                            <div v-on="on">
                              <v-select
                                  outlined
                                  dense
                                  :menu-props="{ offsetY: true }"
                                  item-text="text"
                                  v-on="on"
                                  label="Use dynamic data"
                                  v-model="
                                  currentDefinition.configuration.Analytics
                                    .UseDynamicData
                                "
                                  :items="[
                                  { value: true, text: 'Yes' },
                                  { value: false, text: 'No' },
                                ]"
                              >
                                <template v-slot:item="{ item }">
                                  <p class="mb-0">{{ item.text }}</p>
                                </template>
                              </v-select>
                            </div>
                          </template>
                          <span> Use dynamic data cache for positions </span>
                        </v-tooltip>
                      </v-col>
                      <v-col cols="12" sm="6" class="py-0">
                        <v-tooltip
                            :disabled="isNotDesktop"
                            content-class="tooltipClassBig"
                            bottom
                        >
                          <template v-slot:activator="{ on }">
                            <div v-on="on">
                              <v-text-field
                                  class="analyticsTextFieldClass"
                                  dense
                                  outlined
                                  v-model.number="
                                  currentDefinition.configuration.Analytics
                                    .PositionsPreparedStatementLimit
                                "
                                  type="number"
                                  label="Positions prepared statement limit"
                              ></v-text-field>
                            </div>
                          </template>
                          <span>
                            Deciding factor when to use prepared statement or
                            copy for positions persistence. Only taken into
                            account if positions cache is enabled.
                          </span>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                    <v-row v-if="isAdmin">
                      <v-col cols="12" sm="6" class="py-0">
                        <v-tooltip
                            :disabled="isNotDesktop"
                            content-class="tooltipClassBig"
                            bottom
                        >
                          <template v-slot:activator="{ on }">
                            <div v-on="on">
                              <v-text-field
                                  class="analyticsTextFieldClass"
                                  dense
                                  outlined
                                  v-model.number="
                                  currentDefinition.configuration.Analytics
                                    .PositionsPersistenceCycle
                                "
                                  type="number"
                                  label="Positions Persistence Cycle"
                              ></v-text-field>
                            </div>
                          </template>
                          <span>
                            Period of time in seconds to store<br/>
                            positions in database.
                          </span>
                        </v-tooltip>
                      </v-col>
                      <v-col cols="12" sm="6" class="py-0">
                        <v-tooltip
                            :disabled="isNotDesktop"
                            content-class="tooltipClassBig"
                            bottom
                        >
                          <template v-slot:activator="{ on }">
                            <div v-on="on">
                              <v-select
                                  outlined
                                  dense
                                  :menu-props="{ offsetY: true }"
                                  item-text="text"
                                  v-on="on"
                                  label="Recalculate Trade Profit"
                                  v-model="
                                  currentDefinition.configuration.Analytics
                                    .RecalculateTradeProfit
                                "
                                  :items="[
                                  { value: true, text: 'Yes' },
                                  { value: false, text: 'No' },
                                ]"
                              >
                                <template v-slot:item="{ item }">
                                  <p class="mb-0">{{ item.text }}</p>
                                </template>
                              </v-select>
                            </div>
                          </template>
                          <span>
                            Enables more accurate trade profit calculations at
                            the cost<br/>
                            of performance. Use if profit mismatch is observed
                            in positions
                          </span>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6" class="py-0">
                        <v-tooltip
                            :disabled="isNotDesktop"
                            content-class="tooltipClassBig"
                            bottom
                        >
                          <template v-slot:activator="{ on }">
                            <div v-on="on">
                              <v-select
                                  outlined
                                  dense
                                  :menu-props="{ offsetY: true }"
                                  item-text="text"
                                  v-on="on"
                                  label="Group Summary Items By Symbol"
                                  v-model="
                                  currentDefinition.configuration.Analytics
                                    .GroupSummaryItemsBySymbol
                                "
                                  :items="[
                                  { value: true, text: 'Yes', i: 0 },
                                  { value: false, text: 'No', i: 1 },
                                ]"
                              >
                                <template v-slot:item="{ item }">
                                  <p v-if="item.i === 0" class="mb-0 d-inline">
                                    {{ item.text }}
                                  </p>
                                  <v-tooltip
                                      v-else
                                      content-class="tooltipClassBottom"
                                      bottom
                                  >
                                    <template v-slot:activator="{ on }">
                                      <div
                                          v-on="on"
                                          style="width: 100%; height: 40px"
                                          class="pt-2"
                                      >
                                        <p class="d-inline">{{ item.text }}</p>
                                        <v-icon
                                            color="red"
                                            style="
                                            font-size: 15px;
                                            margin-bottom: 2px;
                                          "
                                            class="ml-2"
                                        >fas fa-exclamation-circle
                                        </v-icon
                                        >
                                      </div>
                                    </template>
                                    <span>
                                      Not recommended for devices with low
                                      processing power.
                                      <br/>e.g old smartphones
                                    </span>
                                  </v-tooltip>
                                </template>
                              </v-select>
                            </div>
                          </template>
                          <span>
                            Period of time in seconds to store a snapshot of
                            users in database
                          </span>
                        </v-tooltip>
                      </v-col>
                      <v-col v-if="isAdmin" cols="12" sm="6" class="py-0">
                        <v-tooltip
                            :disabled="isNotDesktop"
                            content-class="tooltipClassBig"
                            bottom
                        >
                          <template v-slot:activator="{ on }">
                            <div v-on="on">
                              <v-text-field
                                  class="analyticsTextFieldClass"
                                  dense
                                  outlined
                                  label="Positions Dispatch Cycle"
                                  type="number"
                                  v-model.number="
                                  currentDefinition.configuration.Analytics
                                    .PositionsDispatchCycle
                                "
                                  @keydown="
                                  (ev) =>
                                    setHelperVar(ev, 'PositionsDispatchCycle')
                                "
                                  @keypress="
                                  (ev) =>
                                    setHelperVar(ev, 'PositionsDispatchCycle')
                                "
                                  @input="
                                  (ev) =>
                                    textInput(
                                      ev,
                                      currentDefinition.configuration,
                                      'PositionsDispatchCycle'
                                    )
                                "
                                  @focusout="clearHelperVar"
                                  :rules="[rules.required]"
                              ></v-text-field>
                            </div>
                          </template>
                          <span>
                            Position and exposure dispatch to ui interval in
                            seconds
                          </span>
                        </v-tooltip>
                      </v-col>
                    </v-row>

                    <h2 v-if="isAdmin" class="agent-config-category pl-2">
                      Symbols
                    </h2>
                    <v-row v-if="isAdmin">
                      <v-col class="py-0" cols="12" sm="6">
                        <v-tooltip
                            :disabled="isNotDesktop"
                            content-class="tooltipClass"
                            bottom
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                                v-model.number="SymbolsPersistenceCycle"
                                :rules="[rules.required]"
                                v-on="on"
                                class="analyticsTextFieldClass"
                                dense
                                outlined
                                label="Symbols Persistence Cycle"
                                type="number"
                            ></v-text-field>
                          </template>
                          <span>
                            The persistence interval of symbols in seconds.
                          </span>
                        </v-tooltip>
                      </v-col>
                    </v-row>

                    <h2 class="agent-config-category pl-2">Trades</h2>
                    <v-row>
                      <v-col class="py-0" cols="12" sm="6">
                        <v-tooltip
                            :disabled="isNotDesktop"
                            content-class="tooltipClass"
                            bottom
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                                class="analyticsTextFieldClass"
                                dense
                                outlined
                                label="Initial Synchronization Timestamp"
                                type="number"
                                v-model.number="InitialSynchronizationTimestampAN"
                                @keydown="
                                (ev) =>
                                  setHelperVar(
                                    ev,
                                    'InitialSynchronizationTimestampAN'
                                  )
                              "
                                @keypress="
                                (ev) =>
                                  setHelperVar(
                                    ev,
                                    'InitialSynchronizationTimestampAN'
                                  )
                              "
                                @input="
                                (ev) =>
                                  textInput(
                                    ev,
                                    currentDefinition.configuration,
                                    'InitialSynchronizationTimestamp'
                                  )
                              "
                                @change="clearHelperVar"
                                :rules="[rules.required]"
                                v-on="on"
                            ></v-text-field>
                          </template>
                          <span>
                            Defines the initial synchronization starting point
                            in seconds(epoch) e.g. if set to
                            <br/>1262304000 then initial sync will start from
                            Friday, January 1, 2010 12:00:00 AM GMT <br/>Zero
                            value means sync everything
                          </span>
                        </v-tooltip>
                      </v-col>
                      <v-col cols="12" sm="6" class="py-0">
                        <v-tooltip
                            :disabled="isNotDesktop"
                            content-class="tooltipClassBig"
                            bottom
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                                class="analyticsTextFieldClass"
                                dense
                                outlined
                                label="Trades Batch Size"
                                type="number"
                                v-model.number="TradesBatchSizeAN"
                                @keydown="
                                (ev) => setHelperVar(ev, 'TradesBatchSizeAN')
                              "
                                @keypress="
                                (ev) => setHelperVar(ev, 'TradesBatchSizeAN')
                              "
                                @input="
                                (ev) =>
                                  textInput(
                                    ev,
                                    currentDefinition.configuration,
                                    'TradesBatchSize'
                                  )
                              "
                                @focusout="clearHelperVar"
                                v-on="on"
                                :rules="[rules.required]"
                            ></v-text-field>
                          </template>
                          <span>Intended for internal use only</span>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="py-0" cols="12" sm="6">
                        <v-tooltip
                            :disabled="isNotDesktop"
                            content-class="tooltipClass"
                            bottom
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                                class="analyticsTextFieldClass"
                                dense
                                outlined
                                label="Trade Synchronization Cycle"
                                type="number"
                                v-model.number="SynchronizationCycleAN"
                                @keydown="
                                (ev) =>
                                  setHelperVar(ev, 'SynchronizationCycleAN')
                              "
                                @keypress="
                                (ev) =>
                                  setHelperVar(ev, 'SynchronizationCycleAN')
                              "
                                @input="
                                (ev) =>
                                  textInput(
                                    ev,
                                    currentDefinition.configuration,
                                    'SynchronizationCycle'
                                  )
                              "
                                @change="clearHelperVar"
                                :rules="[rules.required]"
                                v-on="on"
                            ></v-text-field>
                          </template>
                          <span>
                            The period of time in milliseconds where the
                            <br/>Synchronization will scan for trade updates
                          </span>
                        </v-tooltip>
                      </v-col>
                      <v-col cols="12" sm="6" class="py-0">
                        <v-tooltip
                            :disabled="isNotDesktop"
                            content-class="tooltipClassBig"
                            bottom
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                                v-on="on"
                                class="analyticsTextFieldClass"
                                dense
                                outlined
                                label="Trades Linger Time"
                                type="number"
                                v-model.number="TradesLingerTimeAN"
                                @keydown="
                                (ev) => setHelperVar(ev, 'TradesLingerTimeAN')
                              "
                                @keypress="
                                (ev) => setHelperVar(ev, 'TradesLingerTimeAN')
                              "
                                @input="
                                (ev) =>
                                  textInput(
                                    ev,
                                    currentDefinition.configuration,
                                    'TradesLingerTime'
                                  )
                              "
                                @focusout="clearHelperVar"
                                :rules="[rules.required]"
                            ></v-text-field>
                          </template>
                          <span>Intended for internal use only</span>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                  </div>
                  <v-row class="pb-2">
                    <v-icon
                        @click="analyticsConfigModel = 0"
                        class="mb-0 mt-2 ml-3 pl-1 clickableText"
                        style="
                        color: #47bd96;
                        font-size: 14px;
                        -webkit-transform: scaleX(-1);
                        transform: scaleX(-1);
                      "
                    >icon-more-23x13
                    </v-icon
                    >
                    <p
                        style="color: #47bd96"
                        class="mb-0 mt-2 pl-1 clickableText"
                        @click="analyticsConfigModel = 0"
                    >
                      General Configurations
                    </p>
                  </v-row>
                </v-tab-item>
                <v-row
                    v-if="
                    selectedApplicationType === applicationTypeEnums.pricewatcher
                  "
                >
                  <symbol-selector
                      v-if="!add"
                      v-model="allPricewatcherSymbols"
                      :PWServerStatus="PWServerStatus"
                      :PWSymbolsState="PWSymbolsState"
                      appCode="PW"
                      class="mb-3"
                  />

                  <!-- <v-row> -->
                  <v-col v-if="isAdmin" class="pb-0 pt-1" cols="12" sm="6">
                    <v-tooltip
                        :disabled="isNotDesktop"
                        content-class="tooltipClassBig"
                        bottom
                    >
                      <template v-slot:activator="{ on }">
                        <div v-on="on">
                          <v-select
                              outlined
                              dense
                              :menu-props="{ offsetY: true }"
                              item-text="text"
                              label="Use debug level"
                              v-model="
                              currentDefinition.priceWatcherConfiguration
                                .use_debug_logs
                            "
                              :items="[
                              { value: true, text: 'Yes' },
                              { value: false, text: 'No' },
                            ]"
                          >
                            <template v-slot:item="{ item }">
                              <p class="mb-0">{{ item.text }}</p>
                            </template>
                          </v-select>
                        </div>
                      </template>
                      <span>Set logs to debug level</span>
                    </v-tooltip>
                  </v-col>
                  <v-col v-if="isAdmin" class="pb-0 pt-1" cols="12" sm="6">
                    <v-tooltip
                        :disabled="isNotDesktop"
                        content-class="tooltipClassBig"
                        bottom
                    >
                      <template v-slot:activator="{ on }">
                        <div v-on="on">
                          <v-select
                              outlined
                              dense
                              :menu-props="{ offsetY: true }"
                              item-text="text"
                              label="Send diffs only"
                              v-model="
                              currentDefinition.priceWatcherConfiguration
                                .send_diffs_only
                            "
                              :items="[
                              { value: true, text: 'Yes' },
                              { value: false, text: 'No' },
                            ]"
                          >
                            <template v-slot:item="{ item }">
                              <p class="mb-0">{{ item.text }}</p>
                            </template>
                          </v-select>
                        </div>
                      </template>
                      <span>Sent only prices that changed since last time</span>
                    </v-tooltip>
                  </v-col>
                  <!-- ........................................................... -->
                  <v-col v-if="isAdmin" class="pb-0 pt-1" cols="12" sm="6">
                    <v-tooltip
                        :disabled="isNotDesktop"
                        content-class="tooltipClassBig"
                        bottom
                    >
                      <template v-slot:activator="{ on }">
                        <div v-on="on">
                          <v-select
                              outlined
                              dense
                              :menu-props="{ offsetY: true }"
                              item-text="text"
                              label="Ignore empty ticks"
                              v-model="
                              currentDefinition.priceWatcherConfiguration
                                .ignore_empty_ticks
                            "
                              :items="[
                              { value: true, text: 'Yes' },
                              { value: false, text: 'No' },
                            ]"
                          >
                            <template v-slot:item="{ item }">
                              <p class="mb-0">{{ item.text }}</p>
                            </template>
                          </v-select>
                        </div>
                      </template>
                      <span
                      >Ignore empty ticks. Empty ticks are the ticks with
                        bid/ask 0 and last update 0.<br/>If SEND_DIFFS_ONLY is
                        set to true empty ticks are never send since the default
                        tick<br/>is an empty one thus no change is detected
                        since the last cycle.</span
                      >
                    </v-tooltip>
                  </v-col>
                  <!-- ........................................................... -->
                  <v-col v-if="isAdmin" class="pb-0 pt-1" cols="12" sm="6">
                    <v-tooltip
                        :disabled="isNotDesktop"
                        content-class="tooltipClassBig"
                        bottom
                    >
                      <template v-slot:activator="{ on }">
                        <div v-on="on">
                          <v-select
                              outlined
                              dense
                              :menu-props="{ offsetY: true }"
                              item-text="text"
                              label="Use UTC time"
                              v-model="
                              currentDefinition.priceWatcherConfiguration
                                .use_utc_time
                            "
                              :items="[
                              { value: true, text: 'Yes' },
                              { value: false, text: 'No' },
                            ]"
                          >
                            <template v-slot:item="{ item }">
                              <p class="mb-0">{{ item.text }}</p>
                            </template>
                          </v-select>
                        </div>
                      </template>
                      <span
                      >Prices are send using utc time. if false they are send
                        in server time</span
                      >
                    </v-tooltip>
                  </v-col>
                  <!-- ........................................................... -->
                  <v-col v-if="isAdmin" class="pb-0 pt-1" cols="12" sm="6">
                    <v-tooltip
                        :disabled="isNotDesktop"
                        content-class="tooltipClassBig"
                        bottom
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                            v-on="on"
                            class="analyticsTextFieldClass"
                            dense
                            outlined
                            label="Ping Interval (s)"
                            type="number"
                            v-model.number="
                            currentDefinition.priceWatcherConfiguration
                              .ping_interval
                          "
                        ></v-text-field>
                      </template>
                      <span>DSDP ping interval in seconds</span>
                    </v-tooltip>
                  </v-col>
                  <!-- ........................................................... -->
                  <v-col v-if="isAdmin" class="pb-0 pt-1" cols="12" sm="6">
                    <v-tooltip
                        :disabled="isNotDesktop"
                        content-class="tooltipClassBig"
                        bottom
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                            v-on="on"
                            class="analyticsTextFieldClass"
                            dense
                            outlined
                            label="Max DSDP join delay (s)"
                            type="number"
                            v-model.number="
                            currentDefinition.priceWatcherConfiguration
                              .max_dsdp_join_delay
                          "
                        ></v-text-field>
                      </template>
                      <span>Max time in seconds for dsdp join requests</span>
                    </v-tooltip>
                  </v-col>
                  <!-- ........................................................... -->
                  <v-col v-if="isAdmin" class="pb-0 pt-1" cols="12" sm="6">
                    <v-tooltip
                        :disabled="isNotDesktop"
                        content-class="tooltipClassBig"
                        bottom
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                            v-on="on"
                            class="analyticsTextFieldClass"
                            dense
                            outlined
                            label="DSDP expire time (s)"
                            type="number"
                            v-model.number="
                            currentDefinition.priceWatcherConfiguration
                              .dsdp_expire_time
                          "
                        ></v-text-field>
                      </template>
                      <span
                      >Time in seconds since last msg received from DSDP.
                        After that communication is considered lost and must be
                        re-established before continuing with the rest of the
                        flow</span
                      >
                    </v-tooltip>
                  </v-col>
                  <v-col v-if="isAdmin" class="pb-0 pt-1" cols="12" sm="6">
                    <v-tooltip
                        :disabled="isNotDesktop"
                        content-class="tooltipClassBig"
                        bottom
                    >
                      <template v-slot:activator="{ on }">
                        <v-select
                            v-on="on"
                            outlined
                            dense
                            :menu-props="{ offsetY: true }"
                            item-text="text"
                            label="Log prices in stats"
                            v-model="
                            currentDefinition.priceWatcherConfiguration
                              .log_prices_in_stats
                          "
                            :items="[
                            { value: true, text: 'Yes' },
                            { value: false, text: 'No' },
                          ]"
                        >
                          <template v-slot:item="{ item }">
                            <p class="mb-0">{{ item.text }}</p>
                          </template>
                        </v-select>
                      </template>
                      <span>Add prices to the statistics logging</span>
                    </v-tooltip>
                  </v-col>
                  <v-col v-if="isAdmin" class="pb-0 pt-1" cols="12" sm="6">
                    <v-tooltip
                        :disabled="isNotDesktop"
                        content-class="tooltipClassBig"
                        bottom
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                            v-on="on"
                            class="analyticsTextFieldClass"
                            dense
                            outlined
                            label="Stats interval"
                            type="number"
                            v-model.number="
                            currentDefinition.priceWatcherConfiguration
                              .stats_interval
                          "
                        ></v-text-field>
                      </template>
                      <span>Interval for statistics logging</span>
                    </v-tooltip>
                  </v-col>
                  <!-- ........................................................... -->
                  <!-- </v-row> -->

                  <!-- :loadingPWsymbols="loadingPWsymbols" -->
                  <!-- :agentConfiguration="currentDefinition.configuration" -->
                </v-row>
              </v-tabs-items>
            </v-container>
          </v-form>
          <v-card-actions
              style="max-height: 46px"
              class="card-actions pt-0 overflowXY-hidden"
          >
            <v-row>
              <v-col
                  :class="`${
                  $vuetify.breakpoint.xsOnly && !add ? 'pt-4' : 'pt-5'
                } mt-1 pl-3`"
                  cols="5"
                  sm="8"
                  md="7"
              >
              </v-col>

              <v-col class="pt-0 pb-3 px-0" cols="7" sm="4" md="5">
                <v-row justify="end" class="pr-3 mr-1">
                  <v-btn text @click="dialog = !dialog" class="mt-3"
                  >Cancel
                  </v-btn
                  >
                  <v-btn
                      color="primary"
                      text
                      @click="
                      $refs.confForm.validate() && validateMultipliersForm()
                        ? saveHandler()
                        : 0
                    "
                      class="mt-3"
                  >Save
                  </v-btn
                  >
                </v-row>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
    <consent-banner v-if="(shouldShowConsent === true) && (this.dialog === true)" @submit="submitConsentHandler"/>
  </v-row>
</template>
<script>
import {
  ApplicationDefinitionService,
  ServerService,
  ApplicationService,
  ApplicationInstanceService,
} from "@/services/ApiService";
import {mapGetters, mapMutations} from "vuex";
import {
  defaultDefinition,
  defaultPriceWatcherDefinition,
  daysOfWeek,
  executionTypes,
  serverVersions,
  encryptionMethods
} from "@/utilities/DefaultObjects.js";
import {
  LoadingPage,
  DefaultPage,
  ConfirmDialog,
} from "../components/Default-Page-Components";
import SymbolSelector from "../components/Configuration/SymbolSelector.vue";
import QuoteConnectionEditDialog from "../components/Configuration/QuoteConnectionEditDialog.vue";
import {PW_SERVER_STATUSES, LOADING_STATES} from "@/utilities/enums";
import InputWrapper from "@/components/UI/InputWrapper.vue";
import {
  updateAppSettingsRemotely
} from "@/services/ApiService";
import {cloneDeep} from "lodash";
import ConsentBanner from "@/components/Configuration/ConsentBanner.vue";

export default {
  components: {
    ConsentBanner,
    InputWrapper,
    ConfirmDialog,
    LoadingPage,
    DefaultPage,
    SymbolSelector,
    QuoteConnectionEditDialog,
  },
  name: "Configurations",
  data() {
    return {
      showConsentDialog: false,
      currentEncryptionMethods: [],
      availableQuoteConnections: ["Fix"],
      serverVersions: serverVersions,
      quoteConnectionEditDialog: false,
      quoteConnectionSelected: {},
      quoteConnectionModel: "Fix",
      quoteConnections: [
        {
          text: "Fix",
          value: "Fix",
          enabled: true,
        },
        {
          text: "Web Socket",
          value: "WebSocket",
          enabled: false,
        },
      ],
      showPassword: true,
      executionTypes: executionTypes,
      PW_SERVER_STATUSES: PW_SERVER_STATUSES,
      PWServerStatus: 0,
      PWSymbolsState: 0,
      fab: false,
      page: 1,
      totalPages: 0,
      itemsPerPage: 25,
      currentParserEditing: null,
      selectedJournalFilterParsers: [],
      selectedApplicationType: null,
      applicationTypeEnums: {
        pricewatcher: 0,
        general: 1,
      },
      applicationTypes: [
        {
          name: "Price Watcher",
          value: 0,
        },
        {
          name: "General (Analytics, Price Guard)",
          value: 1,
        },
      ],
      journalFilterParserFields: [
        {name: "Name", type: "textfield", valueType: "text"},
        {name: "Description", type: "textfield", valueType: "text"},
        {name: "Type", type: "textfield", valueType: "text"},
        {name: "RegexPattern", type: "textfield", valueType: "text"},
        {name: "Separator", type: "textfield", valueType: "text"},
        {name: "Output", type: "textfield", valueType: "text"},
      ],
      journalFilterFields: [
        {name: "Name", type: "textfield", valueType: "text"},
        {name: "Mode", type: "textfield", valueType: "number"},
        {name: "Type", type: "textfield", valueType: "number"},
        {name: "Description", type: "textfield", valueType: "text"},
        {name: "Filter", type: "textfield", valueType: "text"},
        {
          name: "Parsers",
          type: "group",
          fields: [
            {name: "Name", type: "textfield", valueType: "text"},
            {name: "Type", type: "textfield", valueType: "text"},
          ],
        },
      ],
      currentJournalFilter: null,
      journalFiltersDialogModel: false,
      eodFloatingPnlOffsetTimesModel: "Days",
      JournalFiltersModel: "Filters",
      currentPGSelectedSymbols: 0,
      currentPWSelectedSymbols: 0,
      currentPWSymbols: 0,
      currentPGSymbols: 0,
      multipliersSymbol: null,
      multiplier: null,
      PGSymbolsEdited: false,
      PWSymbolsEdited: false,
      instrumentsLoaded: false,
      currentDefinition: {},
      tab: null,
      analyticsModel: true,
      priceGuardModel: true,
      regexSearchPG: false,
      regexSearchPW: false,
      pressedBackSpace: false,
      helperVar: 0,
      itemDeletionText2: "",
      cantDelete: false,
      analyticsConfigModel: 0,
      gotApplicationDefinitions: false,
      gotApps: false,
      itemToDelete: {},
      confirmDialog: false,
      loadingInstruments: false,
      allPriceguardSymbols: [],
      allPricewatcherSymbols: [],
      COLUMN_SORTS: {
        STRINGS: {DESC: 0, ASC: 1},
      },
      selectedHeader: "",
      currentSortingAlgo: (items) => items,
      addNewMapping: false,
      expanded: [],
      serverConnected: false,
      add: false,
      edit: false,
      definitionDialog: false,
      expand: false,
      dialog: false,
      applications: [],
      chosenServer: {},
      servers: [],
      definitions: [],
      selectedExecutionMapping: null,
      availableSymbols: [],
      definitionToAdd: {},
      tradeWatcherDefinition: {
        id: "",
        configuration: {
          PositionProfitThreshold: null,
          PositionVolumeThreshold: null,
          UserSumThreshold: null,
          ExecutionPeriodTime: null,
          GroupMask: null,
        },
        name: "",
        description: "",
      },
      priceGuardDefinition: {
        id: "",
        configuration: [],
        name: "",
        description: "",
      },
      headers: [
        {
          text: "Name",
          value: "name",
          align: "left",
          currentSortAlg: null,
        },
        {
          text: "Application",
          value: "application.name",
          currentSortAlg: null,
        },
        {text: "Description", value: "description", currentSortAlg: null},

        {
          text: "Server",
          value: "server.name",
          currentSortAlg: null,
        },
        {
          text: "Actions",
          value: "configuration",
          currentSortAlg: null,
        },
      ],
      error: false,
      loading: false,
      rules: {
        validRegex: (regex) => {
          return (
              this.isValidRegex(regex, false) || "Invalid regular expression"
          );
        },
        required: (val) => {
          if (!!val || val === 0) {
            return true;
          } else return "Required";
        },
        maxCharDescription: (val) => val === undefined || ((val !== null) && (val.length < 201)),
        maxCharName: (val) => val === undefined || ((val !== null) && (val.length < 51)),
        maxReconnect: (val) => val > 0 && ((val !== null) && (val < 2147483648)),
      },
      valid: false,
      multipliersAddingForm: false,
      multipliersForm: true,
      searchSymbolPG: "",
      searchSymbolPW: "",
    };
  },
  created() {
    if (window.innerWidth > 320 && !this.isNotDesktop) {
      document.getElementById("htmlId").style.overflowY = "hidden";
    }
    this.getApplicationDefitions();
    this.getApps();
  },
  computed: {
    ...mapGetters(["getSettings", "getHasConsented"]),
    /**
     * specify if the consent dialog should be shown based on the
     * current definition configuration's PrivacyPolicyAccepted value and the user's consent status
     */
    shouldShowConsent() {
      return !!(
          this.currentDefinition &&
          this.currentDefinition.configuration &&
          this.currentDefinition.configuration.Analytics &&
          this.currentDefinition.configuration.Analytics.PrivacyPolicyAccepted &&
          (this.currentDefinition.configuration.Analytics.PrivacyPolicyAccepted === true) &&
          (this.getHasConsented === false)
      );
    },
    enabledEodFloatingPnlOffsetTimes() {
      if (
          this.currentDefinition.configuration &&
          this.currentDefinition.configuration.Analytics &&
          this.currentDefinition.configuration.Analytics.EodFloatingPnlOffsetTimes
      )
        return this.currentDefinition.configuration.Analytics.EodFloatingPnlOffsetTimes.filter(
            (el) => el.enabled
        );
      else return [];
    },
    positionAppEnablers() {
      return this.breakpointWidth < 679 && this.breakpointWidth > 599;
    },
    breakpointWidth() {
      return this.$vuetify.breakpoint.width;
    },
    UserSynchronizationCycleAN: {
      get() {
        return this.currentDefinition.configuration.Analytics
            .UserSynchronizationCycle;
      },
      set(v) {
        this.currentDefinition.configuration.Analytics.UserSynchronizationCycle =
            v;
      },
    },
    CycleTime: {
      get() {
        return this.currentDefinition.configuration.PriceGuard.CycleTime;
      },
      set(v) {
        this.currentDefinition.configuration.PriceGuard.CycleTime = v;
      },
    },
    MinifyANMessages: {
      get() {
        return this.currentDefinition.configuration.Analytics.MinifyMessages;
      },
      set(v) {
        this.currentDefinition.configuration.Analytics.MinifyMessages = v;
      },
    },
    // EnableRecoveryMode: {
    //   get() {
    //     console.log('this.currentDefinition.configuration', this.currentDefinition.configuration);
    //     // const parsedConfiguration = JSON.parse(this.currentDefinition.configuration);
    //     // console.log('parsedConfiguration');
    //     // console.log(parsedConfiguration);
    //     return this.currentDefinition.configuration.EnableRecoveryMode;
    //   },
    //   set(v) {
    //     this.currentDefinition.configuration.EnableRecoveryMode = v;
    //   },
    // },
    AcceptableDailyReportDeviationPercentage: {
      get() {
        return this.analyticsDefinition.configuration
            .AcceptableDailyReportDeviationPercentage;
      },
      set(v) {
        this.analyticsDefinition.configuration.AcceptableDailyReportDeviationPercentage =
            v;
      },
    },
    TradesLingerTimeAN: {
      get() {
        return this.currentDefinition.configuration.Analytics.TradesLingerTime;
      },
      set(v) {
        this.currentDefinition.configuration.Analytics.TradesLingerTime = v;
      },
    },
    AiHedgeIntelSynchronizationCycle: {
      get() {
        return this.currentDefinition.configuration.Analytics.AiHedgeIntelSynchronizationCycle || 60;
      },
      set(v) {
        this.currentDefinition.configuration.Analytics.AiHedgeIntelSynchronizationCycle = v;
      },
    },
    HedgeBookRegex: {
      get() {
        return this.currentDefinition.configuration.Analytics.HedgeBookRegex || "(?<book>(^A(?<percentage>(\\\\d+)?))|^B)-Book";
      },
      set(v) {
        this.currentDefinition.configuration.Analytics.HedgeBookRegex = v;
      },
    },
    DefaultPrefetchDailyReports: {
      get() {
        return this.currentDefinition.configuration.Analytics
            .DefaultPrefetchDailyReports;
      },
      set(v) {
        this.currentDefinition.configuration.Analytics.DefaultPrefetchDailyReports =
            v;
      },
    },
    PositionsDispatchCycle: {
      get() {
        return this.currentDefinition.configuration.Analytics
            .PositionsDispatchCycle;
      },
      set(v) {
        this.currentDefinition.configuration.Analytics.PositionsDispatchCycle =
            v;
      },
    },
    TradesBatchSizeAN: {
      get() {
        return this.currentDefinition.configuration.Analytics.TradesBatchSize;
      },
      set(v) {
        this.currentDefinition.configuration.Analytics.TradesBatchSize = v;
      },
    },
    TicksSynchronizationCycleAN: {
      get() {
        return this.currentDefinition.configuration.Analytics
            .TicksSynchronizationCycle;
      },
      set(v) {
        this.currentDefinition.configuration.Analytics.TicksSynchronizationCycle =
            v;
      },
    },
    MaxReconnectRetriesAN: {
      get() {
        return this.currentDefinition.configuration.MaxReconnectRetries;
      },
      set(v) {
        this.currentDefinition.configuration.MaxReconnectRetries = v;
      },
    },
    ReconnectTimeAN: {
      get() {
        return this.currentDefinition.configuration.ReconnectTime;
      },
      set(v) {
        this.currentDefinition.configuration.ReconnectTime = v;
      },
    },
    InitialSynchronizationTimestampAN: {
      get() {
        return this.currentDefinition.configuration.Analytics
            .InitialSynchronizationTimestamp;
      },
      set(v) {
        this.currentDefinition.configuration.Analytics.InitialSynchronizationTimestamp =
            v;
      },
    },
    SynchronizationCycleAN: {
      get() {
        return this.currentDefinition.configuration.Analytics
            .SynchronizationCycle;
      },
      set(v) {
        this.currentDefinition.configuration.Analytics.SynchronizationCycle = v;
      },
    },
    JournalSynchronizationCycle: {
      get() {
        return this.currentDefinition.configuration.Analytics
            .JournalSynchronizationCycle;
      },
      set(v) {
        this.currentDefinition.configuration.Analytics.JournalSynchronizationCycle =
            v;
      },
    },
    DefaultPrefetchJournal: {
      get() {
        return this.currentDefinition.configuration.Analytics
            .DefaultPrefetchJournal;
      },
      set(v) {
        this.currentDefinition.configuration.Analytics.DefaultPrefetchJournal =
            v;
      },
    },
    JournalFetchOffsetTime: {
      get() {
        return this.currentDefinition.configuration.Analytics
            .JournalFetchOffsetTime;
      },
      set(v) {
        this.currentDefinition.configuration.Analytics.JournalFetchOffsetTime =
            v;
      },
    },
    SymbolsPersistenceCycle: {
      get() {
        return this.currentDefinition.configuration.Analytics
            .SymbolsPersistenceCycle;
      },
      set(v) {
        this.currentDefinition.configuration.Analytics.SymbolsPersistenceCycle =
            v;
      },
    },
    GroupEodFloatingPnls: {
      get() {
        return this.currentDefinition.configuration.Analytics
            .GroupEodFloatingPnls;
      },
      set(v) {
        this.currentDefinition.configuration.Analytics.GroupEodFloatingPnls = v;
      },
    },
    ExecutionPeriodTimeAN: {
      get() {
        return this.currentDefinition.configuration.Analytics
            .ExecutionPeriodTime;
      },
      set(v) {
        this.currentDefinition.configuration.Analytics.ExecutionPeriodTime = v;
      },
    },
    DailyReportsFetchOffsetTime: {
      get() {
        return this.currentDefinition.configuration.Analytics
            .DailyReportsFetchOffsetTime;
      },
      set(v) {
        this.currentDefinition.configuration.Analytics.DailyReportsFetchOffsetTime =
            v;
      },
    },
    SecondaryCalculationCurrencies: {
      get() {
        return this.currentDefinition.configuration.Analytics
            .SecondaryCalculationCurrencies;
      },
      set(v) {
        this.currentDefinition.configuration.Analytics.SecondaryCalculationCurrencies =
            v;
      },
    },
    CalculationCurrenciesSuffixes: {
      get() {
        return this.currentDefinition.configuration.Analytics
            .CalculationCurrenciesSuffixes;
      },
      set(v) {
        this.currentDefinition.configuration.Analytics.CalculationCurrenciesSuffixes =
            v;
      },
    },
    IntermediateCurrencies: {
      get() {
        return this.currentDefinition.configuration.Analytics
            .IntermediateCurrencies;
      },
      set(v) {
        this.currentDefinition.configuration.Analytics.IntermediateCurrencies =
            v;
      },
    },
    MissingSymbolsToLiveTicksSynchronizationCycleRatio: {
      get() {
        return this.currentDefinition.configuration.Analytics
            .MissingSymbolsToLiveTicksSynchronizationCycleRatio;
      },
      set(v) {
        this.currentDefinition.configuration.Analytics.MissingSymbolsToLiveTicksSynchronizationCycleRatio =
            v;
      },
    },
    pageWidth() {
      return this.$vuetify.breakpoint.width;
    },
    itemDeletionText() {
      if (this.cantDelete) return "This instance is currently running";
      else
        return Object.keys(this.itemToDelete).length
            ? `Delete configuration ${this.itemToDelete.name}?`
            : "";
    },
    headersCounter() {
      switch (true) {
        case this.$vuetify.breakpoint.width < 411:
          return 1;
        case this.$vuetify.breakpoint.width < 465:
          return 2;
        case this.$vuetify.breakpoint.width < 670:
          return 3;
        case this.$vuetify.breakpoint.width < 803:
          return 4;
        default:
          return this.headers.length;
      }
    },
    checkedPGSymbolsCount() {
      let i = 0;
      this.allPriceguardSymbols.forEach((el) => {
        if (el.checked) i++;
      });
      return i;
    },
    checkedPWSymbolsCount() {
      let i = 0;
      this.allPricewatcherSymbols.forEach((el) => {
        if (el.checked) i++;
      });
      return i;
    },
    tableItems() {
      return this.definitions.map((el, index) => {
        el.index = index;
        let cantDel = this.getApplicationInstances.some((instance) => {
          if (instance.id === el.id) return instance.id === el.id;
        });
        el.cantDelete = !!cantDel;
        return el;
      });
    },
    ...mapGetters("instances", ["getApplicationInstances"]),
    ...mapGetters(["isAdmin"]),
  },
  props: {
    isNotDesktop: {
      type: Boolean,
      default: false,
    },
    windowSizeY: {
      type: Number,
      default: 1200,
    },
  },
  methods: {
    ...mapMutations(["setHasConsented"]),
    /**
     * Handle the personal information consent response
     * @param consentValue {boolean} - The value of the consent
     */
    submitConsentHandler(consentValue) {
      // console.log("consentValue", consentValue);
      this.setHasConsented(consentValue);
      if (consentValue === false) {
        this.currentDefinition.configuration.Analytics.PrivacyPolicyAccepted = false;
      }
      if (consentValue === true) {
        const updatedSettings = cloneDeep(this.getSettings);
        // console.log('updatedSettings', updatedSettings);
        updatedSettings.consent = true;
        this.$store.commit("setHasConsented", consentValue);
        // SettingsService.updateUserSettings({settings: updatedSettings});
        updateAppSettingsRemotely({settings: updatedSettings, recursive: false});
      }
      // if (consentValue === true) {
      //   this.dialog = !this.dialog;
      // }
    },
    serverSelected(server) {
      let usesMTTServer = server.version === serverVersions.MTT;

      if (usesMTTServer) {
        // Select the default quote connection to trigger the "quoteConnectionType" watcher in "QuoteConnectionEditDialog.vue"
        this.quoteConnectionSelected = {
          text: "Fix",
          value: "Fix",
          enabled: true,
        };
      }
    },
    saveQuoteConnection(quoteConnectionProperties) {
      let type = this.quoteConnectionSelected.value;

      if (!type) return;

      let quoteConnectionPropertiesParsed = {};

      quoteConnectionProperties.forEach((el) => {
        quoteConnectionPropertiesParsed[el.name] = el.value;
      });

      this.currentDefinition.configuration[type] =
          quoteConnectionPropertiesParsed;
    },
    editQuoteConnection() {
      this.quoteConnectionEditDialog = !this.quoteConnectionEditDialog;
    },
    selectQuoteConnection(connection) {
      // Deselect all other options, only select the quote connection user selected now
      this.quoteConnections = this.quoteConnections.map((el) => {
        el.enabled = el.value === connection.value;
        return el;
      });
      this.quoteConnectionSelected = connection;

      // Make sure other quote connections are removed from configuration
      this.quoteConnections.forEach((el) => {
        if ((el.value !== connection.value) && this.currentDefinition && this.currentDefinition.configuration && this.currentDefinition.configuration[el.value]) {
          if (el.value !== 'EnableRecoveryMode') {
            delete this.currentDefinition.configuration[el.value];
          }
        }
      });
    },
    applicationTypeChanged(ev) {
      if (
          ev === this.applicationTypeEnums.pricewatcher &&
          !(this.currentDefinition && this.currentDefinition["priceWatcherConfiguration"])
      ) {
        this.currentDefinition.priceWatcherConfiguration = cloneDeep(defaultPriceWatcherDefinition.configuration);
      }
    },
    executionTypeChanged(ev) {
      if (
          ev === "PROCESS" &&
          this.selectedApplicationType === this.applicationTypeEnums.pricewatcher
      ) {
        this.selectedApplicationType = this.applicationTypeEnums.general;
      }
    },
    setAvailableSymbols(appCode) {
      let selectedSymbols =
          appCode === "PW"
              ? this.currentDefinition.configuration.PriceGuard.PriceWatcherSymbols
              : this.currentDefinition.configuration.PriceGuard.WatchedSymbols;
      let unselectedSymbols = this.availableSymbols;

      // Merge selected & unselected arrays
      if (appCode === "PW") {
        this.allPricewatcherSymbols = this.addSelectedSymbols(
            unselectedSymbols,
            selectedSymbols,
            "native-watcher"
        );
      } else
        this.allPriceguardSymbols = this.addSelectedSymbols(
            unselectedSymbols,
            selectedSymbols
        );
    },
    // getDefinitions() {},
    // Merges selected & unselected symbols.
    addSelectedSymbols(
        unselectedSymbols,
        selectedSymbols,
        typeOfConfig = null
    ) {
      let isNativeWatcher = false;

      if (typeOfConfig === "native-watcher") {
        isNativeWatcher = true;
      }

      let processedSymbols = unselectedSymbols.map((el, i) => {
        let nativeWatcher = typeof selectedSymbols[0] == "object";

        let selectedSymbol = selectedSymbols.find((selectedSymbol) =>
            nativeWatcher ? selectedSymbol.name === el : selectedSymbol === el
        );

        if (!isNativeWatcher)
          return {
            checked: selectedSymbol !== undefined,
            index: i,
            value: el,
          };

        let symbolObject = {
          checked: selectedSymbol !== undefined,
          index: i,
          alias: "",
          multiplier: 1,
        };

        // DESCRIPTION:
        // Handle backward compatibility with old price-watcher configurations
        // Used to be and array of strings -> ["EURUSD"], now has an alias & multiplier
        if (selectedSymbol !== undefined && typeof selectedSymbol == "object") {
          symbolObject.value = selectedSymbol.name;

          symbolObject.alias = selectedSymbol["alias"]
              ? selectedSymbol.alias
              : "";

          symbolObject.multiplier = selectedSymbol["multiplier"]
              ? selectedSymbol.multiplier
              : 1;
        } else if (selectedSymbol === undefined) {
          symbolObject.value = el;
        } else {
          symbolObject.value = selectedSymbol;
        }

        return symbolObject;
      });
      return processedSymbols;
    },
    fetchAvailablePWSymbols(definitionId) {
      this.PWSymbolsState = LOADING_STATES.LOADING;

      // let selectedSymbols =
      //   this.currentDefinition.configuration.watched_symbols;

      // this.allPricewatcherSymbols = this.addSelectedSymbols(
      //   unselectedSymbols,
      //   selectedSymbols
      // );
      // Here you should fetch & set the symbols (the selected symbols should be found in the agent config)

      // this.loadingPWsymbols = true;
      var params = {
        command: "CMD_CSM_40",
      };
      ApplicationInstanceService.put(definitionId, params)
          .then((response) => {
            this.availablePWSymbols = response.data.data.all_symbols;

            let selectedSymbols = this.checkPWSymbolsBackwardCompatibility(
                this.currentDefinition?.configuration?.watched_symbols
            );
            let unselectedSymbols = this.availablePWSymbols;

            this.allPricewatcherSymbols = this.addSelectedSymbols(
                unselectedSymbols,
                selectedSymbols,
                "native-watcher"
            ); // Merges the selected & unselected arrays

            this.PWServerStatus = PW_SERVER_STATUSES.CONNECTED;
          })
          .catch((error) => {
            console.error(error);
            this.PWSymbolsState = LOADING_STATES.ERROR;
            if (error.message.search("404"))
              this.PWServerStatus = PW_SERVER_STATUSES.ERROR_404;
            else this.PWServerStatus = PW_SERVER_STATUSES.ERROR;
          })
          .finally(() => (this.PWSymbolsState = LOADING_STATES.LOADED));
    },
    getSelectedSymbols(allSymbols, typeOfConfig = null) {
      let isNativeWatcher = false;

      if (typeOfConfig === "native-watcher") {
        isNativeWatcher = true;
      }

      return allSymbols.reduce((prev, next) => {
        if (next.checked) {
          if (!isNativeWatcher) {
            prev.push(next.value);
          } else {
            let symbol = {
              name: next.value,
            };

            if (next.alias && next.alias.length)
              symbol.alias = next.alias;
            if (next.multiplier && next.multiplier !== 1)
              symbol.multiplier = next.multiplier;

            prev.push(symbol);
          }
        }
        return prev;
      }, []);
    },
    saveConfigurationRemotely(params) {
      try {
        if (params.configuration && params.configuration.Analytics && params.configuration.Analytics["EnableRecovery"]) {
          delete params.configuration.Analytics["EnableRecovery"];
        }
        ApplicationDefinitionService.patch({
          ...params,
          configuration: JSON.stringify(params.configuration),
        })
            .then(() => {
              if (this.PGSymbolsEdited && this.serverConnected) {
                let payload = JSON.stringify(
                    params.configuration.PriceGuard.WatchedSymbols
                );
                ApplicationInstanceService.update(params.id, {
                  command: "CMD_CSM_21",
                  payload: payload,
                });
              }

              // let payload = JSON.stringify(
              //     params.application.code == "PW" ? params.configuration.watched_symbols :
              //     params.configuration.PriceGuard.PriceWatcherSymbols
              //   );
              // TODO
              // In case of native price watcher change the payload
              // + change the CMD_CSM_23 to CMD_CSM_41

              if (
                  this.PWSymbolsEdited &&
                  this.PWServerStatus === PW_SERVER_STATUSES.CONNECTED
              ) {
                let payload = JSON.stringify(
                    params.application.code === "PW"
                        ? params.configuration?.watched_symbols || params.configuration.PriceGuard.PriceWatcherSymbols
                        : params.configuration.PriceGuard.PriceWatcherSymbols
                );

                ApplicationInstanceService.update(params.id, {
                  command:
                      params.application.code === "PW" ? "CMD_CSM_41" : "CMD_CSM_23",
                  payload: payload,
                }).catch((error) => {
                  this.$notifier.error(
                      "Could't reload Price Watcher symbols, please restart the application manually."
                  );
                  console.error(error);
                });
              }

              this.$notifier.info("Configuration saved");
              let executeShortcuts = false;
              this.dialog = false;
              this.getApplicationDefitions(executeShortcuts);
            })
            .catch((error) => {
              this.$notifier.error(
                  "Oops! Something went wrong when saving the configuration...",
                  {error: error}
              );
              console.error(error);
            });
      } catch (error) {
        console.error(error);
        this.$notifier.error("Configuration could not be saved", {
          error: error,
        });
      }
    },
    getDefinitionsQueryParams() {
      return {
        size: this.itemsPerPage,
        page: this.page - 1,
      };
    },
    paginationChangeHandler(page) {
      this.page = page;
      this.getApplicationDefitions();
    },
    removeEmptyAndHelperJournalFiltersFields(journalFilters) {
      let cleanJournalFilters = cloneDeep(journalFilters);
      cleanJournalFilters = cleanJournalFilters.map((filter) => {
        // Remove helper field
        delete filter.id;
        // Remove Empty Parser Fields
        filter.Parsers = filter.Parsers.map((parser) => {
          delete parser.id;
          Object.keys(parser).forEach((parserField) => {
            if (!parser[parserField]) {
              delete parser[parserField];
            }
          });
          return parser;
        });

        return filter;
      });
      return cleanJournalFilters;
    },
    addJournalFilter() {
      let id = Date.now();

      let newJournalFilter = {
        Name: `New Filter`,
        Mode: "",
        Type: "",
        Description: "",
        Filter: "",
        Parsers: [],
        id: id,
      };
      // Add default values depending on server version (MT4/MT5)
      if (this.chosenServer) {
        let serverVersion = this.edit
            ? this.currentDefinition.server.version
            : this.chosenServer.version;

        switch (serverVersion) {
          case "MT5":
            newJournalFilter.Mode = 2;
            newJournalFilter.Type = 0;
            break;
          case "MT4":
            newJournalFilter.Type = 4;
        }
      }

      this.currentDefinition.configuration.Analytics.JournalFilters.unshift(
          newJournalFilter
      );
    },
    editCustomJournalFilterParser(parser) {
      this.currentParserEditing = parser;
    },
    deleteCustomJournalFilterParser(parser) {
      if (
          this.currentParserEditing &&
          this.currentParserEditing.id === parser.id
      )
        this.currentParserEditing = null;
      this.currentJournalFilter.Parsers =
          this.currentJournalFilter.Parsers.filter((el) => el.id !== parser.id);

      // Remove from selectedJournalFilterParsers
      this.selectedJournalFilterParsers =
          this.selectedJournalFilterParsers.filter((el) => el.id !== parser.id);
    },
    addCustomParser() {
      let id = Date.now();
      this.currentJournalFilter.Parsers.unshift({
        Name: "New Parser",
        Description: "",
        Type: "",
        RegexPattern: "",
        Separator: "",
        Output: "",
        id: id,
      });
    },
    preprocessJournalFilters(AnalyticsConfigs) {
      let setId = (el, i) => {
        el.id = i;
        return el;
      };
      if (AnalyticsConfigs.JournalFilters)
        return AnalyticsConfigs.JournalFilters.map(setId);
      else
        return cloneDeep(
            defaultDefinition.configuration.Analytics.JournalFilters
        ).map(setId);
    },
    saveJournalFilter() {
      let journalFilters =
          this.currentDefinition.configuration.Analytics.JournalFilters;
      let index = journalFilters.findIndex(
          (el) => el.id === this.currentJournalFilter.id
      );
      // Remove the parsers that wern't selected
      let cleanJournalFilter = JSON.parse(
          JSON.stringify(this.currentJournalFilter)
      );
      let finalFilter = Object.assign(cleanJournalFilter, {
        Parsers: cloneDeep(this.selectedJournalFilterParsers),
      });
      //
      journalFilters[index] = finalFilter;

      this.journalFiltersDialogModel = false;
    },
    editJournalFilter(filter) {
      this.currentJournalFilter = cloneDeep(filter);
      if (this.currentJournalFilter.Parsers)
        this.selectedJournalFilterParsers = JSON.parse(
            JSON.stringify(this.currentJournalFilter.Parsers)
        );
      this.journalFiltersDialogModel = !this.journalFiltersDialogModel;
    },
    deleteJournalFilter(filter) {
      let analyticsConfig = this.currentDefinition.configuration.Analytics;
      analyticsConfig.JournalFilters = analyticsConfig.JournalFilters.filter(
          (el) => el.id !== filter.id
      );
    },
    // Parse in to back-end readable
    parseEodFloatingPnlOffsetTimesForBE(configuration) {
      let parsedEodFloatingPnlOffsetTimes = {};

      configuration.Analytics.EodFloatingPnlOffsetTimes.forEach((el) => {
        if (el.enabled)
          parsedEodFloatingPnlOffsetTimes[el.dayName] = {
            From: el.From,
            To: el.To,
          };
      });

      return parsedEodFloatingPnlOffsetTimes;
    },
    // Add helper field / re-structure the data / add default data
    parseEodFloatingPnlOffsetTimes(savedTimes, disableAll = false) {
      let days = [];
      try {
        let savedDays;
        if (!savedTimes) savedDays = [];
        else {
          // If savedTimes is already parsed just return it (this config might have been opened previously)
          if (Array.isArray(savedTimes))
            return cloneDeep(savedTimes);
          savedDays = Object.keys(savedTimes);
        }

        daysOfWeek.forEach((day) => {
          let dayEnabled = false;
          if (!disableAll) dayEnabled = savedDays.includes(day);

          if (dayEnabled)
            days.push({
              dayName: day,
              enabled: dayEnabled,
              From: savedTimes[day].From,
              To: savedTimes[day].To,
            });
          else
            days.push({
              dayName: day,
              enabled: dayEnabled,
              From: 300,
              To: 1800,
            });
        });
        return days;
      } catch (error) {
        if (this.isAdmin)
          this.$notifier.error(
              `Oops! Couldn't load EodFloatingPnlOffsetTimes.`
          );
        else this.$notifier.error("Oops! Couldn't load some configurations.");

        daysOfWeek.forEach((day) => {
          days.push({dayName: day, enabled: false, From: 300, To: 1800});
        });
        return days;
      }
    },
    recalculateSelectedPGSymbolsLength() {
      let selected = 0;
      this.$refs.PGSymbolsTable.internalCurrentItems.forEach((el) => {
        if (el.checked) selected++;
      });
      this.currentPGSelectedSymbols = selected;
    },
    recalculateSelectedPWSymbolsLength() {
      let selected = 0;
      this.$refs.PWSymbolsTable.internalCurrentItems.forEach((el) => {
        if (el.checked) selected++;
      });
      this.currentPWSelectedSymbols = selected;
    },
    PGSymbolSelected(item) {
      item.checked = !item.checked;
      item.checked
          ? this.currentPGSelectedSymbols++
          : this.currentPGSelectedSymbols--;
      this.recalculateSelectedPGSymbolsLength();
    },
    PWSymbolSelected(item) {
      item.checked = !item.checked;
      item.checked
          ? this.currentPGSelectedSymbols++
          : this.currentPGSelectedSymbols--;
      this.recalculateSelectedPWSymbolsLength();
    },
    setCurrentPGSymbols(items) {
      this.currentPGSymbols = items.length;
      this.currentPGSelectedSymbols = items.reduce((final, next) => {
        if (next.checked) final++;
        return final;
      }, 0);
    },
    setCurrentPWSymbols(items) {
      this.currentPWSymbols = items.length;
      this.currentPWSelectedSymbols = items.reduce((final, next) => {
        if (next.checked) final++;
        return final;
      }, 0);
    },
    validateMultipliersForm() {
      return this.$refs.multipliersForm
          ? this.$refs.multipliersForm.validate()
          : true;
    },
    parseSymbolsMultipliers(configuration) {
      if (!configuration.SymbolsMultipliers.length)
        configuration.SymbolsMultipliers = {};
      else {
        let SymbolsMultipliersParsed = {};
        configuration.SymbolsMultipliers.forEach((el) => {
          SymbolsMultipliersParsed[el.details[0]] = el.details[1];
        });
        configuration.SymbolsMultipliers = SymbolsMultipliersParsed;
      }
    },
    deleteMultiplier(id) {
      this.currentDefinition.configuration.Analytics.SymbolsMultipliers =
          this.currentDefinition.configuration.Analytics.SymbolsMultipliers.filter(
              (el) => el.id !== id
          );
    },
    listContainsId(id, list) {
      return list.some((el) => el.id === id);
    },
    // Create the new multiplier object and push it to SymbolsMultipliers array
    addCurMultiplier() {
      let symbolsMultipliers =
          this.currentDefinition.configuration.Analytics.SymbolsMultipliers;
      let newMultiplier = {
        details: [this.multipliersSymbol, this.multiplier],
        id: this.multipliersSymbol,
      };

      let idExists = this.listContainsId(
          this.multipliersSymbol,
          symbolsMultipliers
      );

      if (idExists) {
        newMultiplier.id = this.multipliersSymbol + symbolsMultipliers.length;
      }

      this.currentDefinition.configuration.Analytics.SymbolsMultipliers.push(
          newMultiplier
      );
      this.multipliersSymbol = null;
      this.multiplier = null;
      this.$refs.multipliersAddingForm.reset();
      newMultiplier = null;
    },
    PWTabClicked(definitionId) {
      if (!this.PWSymbolsEdited && this.instrumentsLoaded) {
        this.setAvailableSymbols("PW");
      } else if (!this.instrumentsLoaded && this.edit) {
        this.getInstruments(definitionId, "PW");
      }
      //   this.calculatePWSymbols(definitionId);
      if (!this.PWSymbolsEdited) this.PWSymbolsEdited = true;
      // In case the PW tab wasn't edited yet but the instruments are already loaded, just set the available symbols
    },
    PGTabClicked(definitionId) {
      if (!this.edit) return;
      if (!this.instrumentsLoaded) this.getInstruments(definitionId, "PG");
      else {
        if (!this.PGSymbolsEdited) this.setAvailableSymbols("PG");
        this.serverConnected = true;
        this.loadingInstruments = false;
      }
      this.PGSymbolsEdited = true;
    },
    // calculatePWSymbols(definitionId) {
    //   // let selectedSymbols;
    //   // let watchedSymbols =
    //   //   this.currentDefinition.configuration.PriceGuard.WatchedSymbols;

    //   // // WITH this.PGSymbolsEdited you know that PG Symbols might have been edited so in this case take the "selected" symbols
    //   // // form the UI
    //   // if (this.PGSymbolsEdited)
    //   //   selectedSymbols = this.getSelectedSymbols(this.allPriceguardSymbols);
    //   // // Otherwise take the selected symbols from the agent configuration
    //   // else selectedSymbols = cloneDeep(watchedSymbols));

    //   // if (this.PGSymbolsEdited)
    //   //   selectedSymbols = this.getSelectedSymbols(this.allPriceguardSymbols);

    //   // else selectedSymbols = cloneDeep(watchedSymbols));

    //   let unselectedSymbols = this.availableSymbols
    //   let selectedSymbols = this.currentDefinition.configuration.PriceGuard.PriceWatcherSymbols;

    //   // TODO
    //   // Instead of using selectedSymbols -> use all symbols available that were fetched in getInstruments()
    //   this.allPricewatcherSymbols = this.addSelectedSymbols(
    //     unselectedSymbols,
    //     selectedSymbols
    //   );

    //   // let availablePriceWatcherSymbols = selectedSymbols.map((el, i) => {
    //   //   let checked = false;

    //     // Select the Price Watcher symbols that were selected from before
    //     // if (
    //     //   this.currentDefinition.configuration.PriceGuard.PriceWatcherSymbols
    //     // ) {
    //     //   checked =
    //     //     this.currentDefinition.configuration.PriceGuard.PriceWatcherSymbols.findIndex(
    //     //       (watched) => watched == el
    //     //     ) != -1;
    //     //   if (!checked)
    //     //     checked = this.allPricewatcherSymbols.some(
    //     //       (symbol) => symbol.value == el && symbol.checked
    //     //     );
    //     // }

    //   //   return {
    //   //     value: el,
    //   //     checked: checked,
    //   //     index: i,
    //   //   };
    //   // });
    //   // this.allPricewatcherSymbols = availablePriceWatcherSymbols;
    // },
    isValidRegex(regexStr, returnRegex = true) {
      var isValid = true;
      try {
        var regex = new RegExp(regexStr);
      } catch (e) {
        isValid = false;
      }

      if (returnRegex && regex !== undefined) {
        return regex;
      } else return isValid;
    },
    symbolSearchFilter(value, search) {
      let regexSearch = this.tab === 2 ? this.regexSearchPW : this.regexSearchPG;
      if (regexSearch) {
        let regex = this.isValidRegex(search);
        if (regex) {
          return search != null && regex.test(value);
        } else return false;
      } else return search != null && value.indexOf(search) !== -1;
    },
    clearHelperVar() {
      this.helperVar = null;
    },
    setHelperVar(ev, prop) {
      if (ev.keyCode === 8) {
        this.pressedBackSpace = true;
      } else {
        const pattern = /^\d*(\.\d+)*(\d\.+)?$/;
        if (pattern.test(this[prop])) {
          this.helperVar = this[prop];
        } else {
          pattern.test(this[prop]);
        }
      }
    },
    textInput(val, obj, prop) {
      const pattern = /^\d*(\.\d+)*(\d\.+)?$/;
      if (!pattern.test(val) || (!!val && (val.length === 0) && !this.pressedBackSpace)) {
        this.$nextTick(() => {
          if (typeof this.helperVar == "string" && !this.helperVar.length) {
            obj[prop] = 0;
          } else {
            obj[prop] = this.helperVar;
          }
        });
        this.pressedBackSpace = false;
      } else {
        this.pressedBackSpace = false;
      }
    },
    parseArrayString(data, parseProp, multipleArrays) {
      if (multipleArrays) {
        return data.map((val) => {
          if (typeof val[parseProp] == "string") {
            let loginsArray;

            loginsArray = val[parseProp].split(",");

            val[parseProp] = loginsArray.map((el) => parseInt(el, 10));
          }

          val[parseProp] = val[parseProp].filter((num) => {
            return !(num == null || isNaN(num));
          });

          return val;
        });
      } else {
        if (typeof data[parseProp] == "string") {
          let loginsArray = [];

          loginsArray = data[parseProp].split(",");
          data[parseProp] = loginsArray.map((el) => parseInt(el, 10));
        }

        data[parseProp] = data[parseProp].filter((num) => {
          return !(num == null || isNaN(num));
        });
        return data;
      }
    },
    async terminateAndDeleteConfig(confirmDeletion) {
      if (confirmDeletion) {
        await ApplicationInstanceService.delete(this.itemToDelete.id)
            .then(() => {
              this.deleteConfig(true);
            })
            .catch((error) => {
              console.error(error);
              this.$notifier.error(error.response.data.message, {error: error});
            });
      }
      this.confirmDialog = !this.confirmDialog;
    },
    getCellTextClass(value) {
      switch (value) {
        case "description":
          return "char-lim ml-3";
        case "name":
          if (this.headersCounter !== this.headers.length) {
            if (this.headersCounter === 1) return "char-lim ml-1";
            else return "float-left char-lim ml-1";
          } else return "char-lim ml-3";

        default:
          return "d-inline ml-1";
      }
    },
    checkPWSymbolsBackwardCompatibility(symbols) {
      if (!symbols.length) return symbols;
      else if (typeof symbols[0] == "string") {
        return symbols.map((el) => {
          return {name: el};
        });
      } else return symbols;
    },
    checkPWBackwardCompatibility(configuration) {
      let defaultDef = JSON.parse(
          JSON.stringify(defaultPriceWatcherDefinition.configuration)
      );

      let compatibleConfig = Object.assign(defaultDef, configuration);

      return compatibleConfig;
    },
    checkBackwardCompatibility(configuration) {
      let defaultDef = cloneDeep(defaultDefinition.configuration);

      let compatibleConfig = {
        ...defaultDef,
        ...configuration,
        ConnectionPingCycle: configuration.ConnectionPingCycle,
        MaxReconnectRetries: configuration.MaxReconnectRetries,
        ReconnectTime: configuration.ReconnectTime,
        ServerName: configuration.ServerName,
      };
      compatibleConfig.Analytics = Object.assign(
          defaultDef.Analytics,
          configuration.Analytics
      );
      compatibleConfig.PriceGuard = Object.assign(
          defaultDef.PriceGuard,
          configuration.PriceGuard
      );

      // Add quote connection
      let hasFix = !!configuration["Fix"];
      let hasWebSocket = !!configuration["WebSocket"];
      if (hasFix) compatibleConfig.Fix = configuration.Fix;
      if (hasWebSocket) compatibleConfig.WebSocket = configuration.WebSocket;

      return compatibleConfig;
    },
    executeShortCuts() {
      if (this.gotApplicationDefinitions && this.gotApps) {
        if (this.$route.query.edit) {
          let itemToEdit = this.tableItems.find(
              (el) => el.id === this.$route.query.edit
          );
          if (itemToEdit) {
            this.editConfiguration(itemToEdit);
            this.dialog = true;
            // if(hasConsemted) {
            //   this.dialog = false;
            // }
          }
          this.$router.replace({query: null});
        }
      }
    },
    getStarted() {
      if (this.error) this.reloadThisPage();
      else this.openDefinitionDialog();
    },
    mutateConfirmDialog(value) {
      this.confirmDialog = value;
    },
    confirmationDialog(item) {
      this.itemToDelete = item;
      if (item.cantDelete) {
        this.cantDelete = true;
        this.itemDeletionText2 =
            "Deleting the configuration, will terminate the instance";
      } else {
        this.cantDelete = false;
        this.itemDeletionText2 = "";
      }
      this.confirmDialog = !this.confirmDialog;
    },

    getProperties(item, firstLevel) {
      return firstLevel ? item.split(".")[0] : item.split(".")[1];
    },
    secondarySort(items, typeAndOrder) {
      switch (typeAndOrder) {
        case this.COLUMN_SORTS.STRINGS.ASC:
          let selectedHeader = this.selectedHeader.split(".");
          if (selectedHeader.length > 1) {
            let x = items.sort((a, b) =>
                a[selectedHeader[0]][selectedHeader[1]] >
                b[selectedHeader[0]][selectedHeader[1]]
                    ? 1
                    : b[selectedHeader[0]][selectedHeader[1]] >
                    a[selectedHeader[0]][selectedHeader[1]]
                        ? -1
                        : 0
            );
            return x;
          } else {
            let x = items.sort((a, b) =>
                a[this.selectedHeader] > b[this.selectedHeader]
                    ? 1
                    : b[this.selectedHeader] > a[this.selectedHeader]
                        ? -1
                        : 0
            );
            return x;
          }
        case this.COLUMN_SORTS.STRINGS.DESC:
          return items.sort((a, b) =>
              b[this.selectedHeader] > a[this.selectedHeader]
                  ? 1
                  : a[this.selectedHeader] > b[this.selectedHeader]
                      ? -1
                      : 0
          );
        default:
          return;
      }
    },
    getSortingIcon(algo) {
      switch (algo) {
        case this.COLUMN_SORTS.STRINGS.ASC:
          return "fas fa-arrow-down";
        default:
          return "fas fa-arrow-up";
      }
    },
    stringSortAsc(items) {
      return this.secondarySort(items, this.COLUMN_SORTS.STRINGS.ASC);
    },
    stringSortDesc(items) {
      return this.secondarySort(items, this.COLUMN_SORTS.STRINGS.DESC);
    },
    clearAllHeadersSorting(header) {
      this.headers.map((el) => {
        if (el.text !== header.text && el.currentSortAlg != null) {
          el.currentSortAlg = null;
          return el;
        } else {
          return el;
        }
      });
    },
    getNewSortingAlgo(header) {
      if (header.text !== this.selectedSort) {
        this.selectedSort = this.headers.find(
            (el) => el.value === header.value
        ).text;
      }
      if (
          header.currentSortAlg == null ||
          header.currentSortAlg === this.COLUMN_SORTS.STRINGS.DESC
      ) {
        header.currentSortAlg = this.COLUMN_SORTS.STRINGS.ASC;
        this.clearAllHeadersSorting(header);
        return this.stringSortAsc;
      } else {
        header.currentSortAlg = this.COLUMN_SORTS.STRINGS.DESC;
        this.clearAllHeadersSorting(header);
        return this.stringSortDesc;
      }
    },
    expandRow(item) {
      if (this.expanded.length) {
        if (this.expanded[0].id === item.id) {
          this.expanded.pop();
        } else {
          this.expanded.pop();
          this.expanded.push(item);
        }
      } else {
        this.expanded.push(item);
      }
    },
    reloadThisPage() {
      this.getApplicationDefitions();
      this.getApps();
    },
    getInstruments(definitionId, appCode) {
      this.error = null;
      this.loadingInstruments = true;
      var params = {
        command: "CMD_CSM_20",
      };
      ApplicationInstanceService.put(definitionId, params)
          .then((response) => {
            this.instrumentsLoaded = true;
            this.availableSymbols = response.data.data;

            this.setAvailableSymbols(appCode);

            // this.allPriceguardSymbols = this.availableSymbols.map((el, i) => {
            //   let checked =
            //     this.currentDefinition.configuration.PriceGuard.WatchedSymbols.find(
            //       (val) => {
            //         return val == el;
            //       }
            //     );
            //   if (checked != undefined) {
            //     selectedSymbols++;
            //   }
            //   return {
            //     checked: checked != undefined ? true : false,
            //     index: i,
            //     value: el,
            //   };
            // });
            this.serverConnected = true;
            this.loadingInstruments = false;
          })
          .catch((error) => {
            console.error(error);
            this.loadingInstruments = false;
            this.serverConnected = false;
          })
          .finally(() => (this.loadingInstruments = false));
    },
    postNewConfig(params) {
      ApplicationDefinitionService.post(params)
          .then((res) => {
            this.$notifier.info("Configuration added");
            this.refreshConfigs();
          })
          .catch((error) => {
            console.error(error);
            this.$notifier.error("Configuration couldn't be added", {
              error: error,
            });
          });
    },
    refreshConfigs(extraParams = null) {
      let params = this.getDefinitionsQueryParams();
      if (extraParams != null) params = Object.assign(params, extraParams);

      ApplicationDefinitionService.query({params: params})
          // ApplicationDefinitionService.get()
          .then((response) => {
            try {
              this.definitions = response.data.content;
              this.totalPages = response.data.totalPages;
            } catch (error) {
              console.error(error);
              if (this.isAdmin)
                this.$notifier.error(
                    "Definitions received from server have an error!"
                );
            }
          })
          .catch((error) => {
            console.error(error);
            this.$notifier.error("Could not refresh the data.", {error: error});
          });
    },
    getApps(loading = true) {
      if (loading) {
        this.loading = true;
      }

      ApplicationService.get()
          .then((response) => {
            this.loading = false;
            this.applications = response.data;
          })
          .catch((error) => {
            console.error(error);
            this.errorMessage = error;
            this.error = true;
          })
          .finally(() => {
            this.gotApps = true;
            this.loading = false;
            this.executeShortCuts();
          });
    },
    getServers() {
      let params = {
        page: 0,
        size: 9999,
      };
      ServerService.query({params: params})
          .then((response) => {
            this.servers = response.data.content;
          })
          .catch((error) => {
            console.error(error);
            this.errorMessage = error;
            this.error = true;
          });
    },
    getApplicationDefitions(executeShortcuts = true) {
      this.error = null;
      this.loading = true;
      let editConfig = this.$route.query.edit;
      let params = editConfig
          ? {size: 9999, page: 0}
          : this.getDefinitionsQueryParams();

      ApplicationDefinitionService.query({params: params})
          // ApplicationDefinitionService.get()
          .then((response) => {
            try {
              let data = response.data;
              let configs = data.content;
              if (editConfig) {
                let indexOfConfig = configs.findIndex(
                    (el) => el.id === editConfig
                );
                if (indexOfConfig) {
                  this.totalPages = Math.ceil(configs.length / 25);
                  this.page =
                      indexOfConfig === 0 ? 1 : Math.ceil((indexOfConfig + 1) / 25);

                  // this.definitions = configs.filter(
                  //   (el, i) => i >= (this.page - 1) * 25 && i < (this.page - 1) * 25 + 25
                  // );
                  let definitionsOfPage = [];
                  configs.forEach((el, i) => {
                    if (
                        i >= (this.page - 1) * 25 &&
                        i < (this.page - 1) * 25 + 25
                    )
                      definitionsOfPage.push(el);
                  });
                  this.definitions = definitionsOfPage;
                } else {
                  // Cover case where something went wrong and the server didnt return the config you need to edit
                  this.definitions = configs.filter((el, i) => i < 25);
                  this.totalPages = data.totalPages;
                }
              } else {
                this.definitions = configs;
                this.totalPages = data.totalPages;
              }
            } catch (error) {
              if (this.isAdmin)
                this.$notifier.error(
                    "Configurations received from server have an error!"
                );
              console.error(error);
            }
          })
          .catch((error) => {
            console.error(error);
            this.errorMessage = error;
            this.error = true;
          })
          .finally(() => {
            this.gotApplicationDefinitions = true;
            this.loading = false;
            if (executeShortcuts) this.executeShortCuts();
          });
    },
    addExecutionMapping(mapsLength) {
      if (mapsLength) {
        this.addNewMapping = true;
        setTimeout(() => {
          this.addNewMapping = false;
        }, 300);
      }
      let executionMappings =
          this.currentDefinition.configuration.Analytics.ExecutionMappings;

      let mappings = executionMappings;
      let id =
          mappings.length === 0
              ? 0
              : Math.max.apply(
              null,
              executionMappings.map((o) => o.Id)
          ) + 1;
      executionMappings.push({
        SplitExecutionMappingId: -1,
        Id: id,
        GroupPattern: "",
        Logins: [],
        Percentage: 100,
        SplitPercentage: 0,
        Name: "New Book",
        SymbolPattern: "",
      });
      this.selectedExecutionMapping = executionMappings.find(
          (el) => el.Id === id
      );
    },
    clearDialog() {
      // Priceguard modal
      if (this.instrumentsLoaded) this.instrumentsLoaded = false;
      if (this.regexSearchPG) this.regexSearchPG = false;
      this.searchSymbolPG = "";
      this.searchSymbolPW = "";

      this.$nextTick(() => {
        this.$refs.confForm.reset();
      });

      this.chosenServer = {};
      this.selectedApplicationType = null;
      this.analyticsConfigModel = 0;
      // General
      this.showPassword = true;
      this.selectedExecutionMapping = null;
      this.availableSymbols = [];
      this.expand = false;

      // Priceguard modal
      this.PGSymbolsEdited = false;
      this.PWSymbolsEdited = false;

      // Pricewatcher modal
      this.PWSymbolsState = LOADING_STATES.DEFAULT;

      // Analytics modal
      this.multiplier = null;
      this.multipliersSymbol = null;

      // Fix
      setTimeout(() => {
        this.quoteConnectionModel = "Fix";
        this.availableQuoteConnections = ["Fix"];
      }, 1000);

      // Reset symbols multipliers validation if exists
      if (this.$refs.form && this.$refs.form.reset) this.$refs.form.reset();

      setTimeout(() => {
        this.serverConnected = false;
        this.PWServerStatus = PW_SERVER_STATUSES.CONNECTED;
        this.allPriceguardSymbols = [];
        this.allPricewatcherSymbols = [];

        this.tab = null;
      }, 200);
    },
    saveEditedConfiguration() {
      // Saving the configuration of a Native Price Watcher...
      if (
          this.selectedApplicationType === this.applicationTypeEnums.pricewatcher
      ) {
        // DESCRIPTION:
        // If PWServerStatus is connected, then save the edited symbols
        if ((this.PWServerStatus === PW_SERVER_STATUSES.CONNECTED) && this.currentDefinition && this.currentDefinition.configuration && this.currentDefinition.configuration.watched_symbols) {
          this.currentDefinition.configuration.watched_symbols =
              this.getSelectedSymbols(
                  this.allPricewatcherSymbols,
                  "native-watcher"
              );
        }

        // TODO Fix this workaround (used to have the same PW html fields in "Edit" dialog & "Add" dialog)
        this.currentDefinition.configuration = {
          ...this.currentDefinition.configuration,
          ...this.currentDefinition.priceWatcherConfiguration,
          watched_symbols:
              this.currentDefinition?.configuration?.watched_symbols?.map((el) => {
                if (!el.multiplier || el.multiplier === 1) delete el.multiplier;
                return el;
              }),
        };
        this.saveConfigurationRemotely(this.currentDefinition);
        return;
      }

      var params = cloneDeep(this.currentDefinition);

      // if (this.selectedApplicationType == this.applicationTypeEnums.pricewatcher) {
      //   params.configuration.watched_symbols = this.getSelectedSymbols(this.allPricewatcherSymbols)
      //   this.saveConfigurationRemotely(params);
      //   return;
      // }

      let ANconfiguration = params.configuration.Analytics;

      if (
          ANconfiguration.ExcludeServices.length &&
          typeof ANconfiguration.ExcludeServices == "string"
      ) {
        ANconfiguration.ExcludeServices =
            ANconfiguration.ExcludeServices.split(",");
      }

      if (
          ANconfiguration.SecondaryCalculationCurrencies &&
          (ANconfiguration.SecondaryCalculationCurrencies.length > 0) &&
          (typeof ANconfiguration.SecondaryCalculationCurrencies == "string")
      ) {
        ANconfiguration.SecondaryCalculationCurrencies = ANconfiguration.SecondaryCalculationCurrencies.replace(/ /g, '').split(",");
      }

      if (
          ANconfiguration.CalculationCurrenciesSuffixes &&
          (ANconfiguration.CalculationCurrenciesSuffixes.length > 0) &&
          (typeof ANconfiguration.CalculationCurrenciesSuffixes == "string")
      ) {
        ANconfiguration.CalculationCurrenciesSuffixes = ANconfiguration.CalculationCurrenciesSuffixes.replace(/ /g, '').split(",");
      }

      if (
          ANconfiguration.IntermediateCurrencies &&
          (ANconfiguration.IntermediateCurrencies.length > 0) &&
          (typeof ANconfiguration.IntermediateCurrencies == "string")
      ) {
        ANconfiguration.IntermediateCurrencies = ANconfiguration.IntermediateCurrencies.replace(/ /g, '').split(",");
      }

      // Parse array strings to int arrays
      let mappings = ANconfiguration.ExecutionMappings;

      mappings = this.parseArrayString(mappings, "Logins", true);
      let ANconfigurationParsed = this.parseArrayString(
          ANconfiguration,
          "ExcludeLogins",
          false
      );
      ANconfiguration.ExcludeLogins = cloneDeep(ANconfigurationParsed.ExcludeLogins);

      // Parse SymbolsMultipliers from array to object

      this.parseSymbolsMultipliers(params.configuration.Analytics);

      // // If tab is not 2(Price wathcer) that means PG symbols might have been edited
      // // in a way affecting the PW symbols so recalculate them for safety.
      // if (this.tab != 2) this.calculatePWSymbols(this.currentDefinition.id);

      if (this.serverConnected) {
        if (this.PGSymbolsEdited) {
          params.configuration.PriceGuard.WatchedSymbols =
              this.getSelectedSymbols(this.allPriceguardSymbols);
        }
        if (this.PWSymbolsEdited) {
          params.configuration.PriceGuard.PriceWatcherSymbols =
              this.getSelectedSymbols(this.allPricewatcherSymbols);
        }
        // let tempSymbols = JSON.parse(
        //   JSON.stringify(params.configuration.PriceGuard.PriceWatcherSymbols)
        // );
      }

      params.configuration.PriceGuard.Enabled = this.priceGuardModel;
      params.configuration.Analytics.Enabled = this.analyticsModel;

      params.configuration.Analytics.EodFloatingPnlOffsetTimes =
          this.parseEodFloatingPnlOffsetTimesForBE(params.configuration);

      params.configuration.Analytics.JournalFilters =
          this.removeEmptyAndHelperJournalFiltersFields(
              params.configuration.Analytics.JournalFilters
          );

      this.saveConfigurationRemotely(params);
    },
    deleteMapping() {
      let mappingId = this.selectedExecutionMapping.Id;
      // use css effect
      this.addNewMapping = true;
      setTimeout(() => {
        this.addNewMapping = false;
      }, 300);
      let ExecutionMappings =
          this.currentDefinition.configuration.Analytics.ExecutionMappings;

      let index = ExecutionMappings.findIndex((el) => el.Id === mappingId);
      if (index !== -1) {
        ExecutionMappings.splice(index, 1);
      }

      if (ExecutionMappings.length) {
        let maxId = -1;
        let maxIdIndex;
        ExecutionMappings.forEach((el, index) => {
          if (el.Id > maxId) {
            maxId = el.Id;
            maxIdIndex = index;
          }
        });
        this.selectedExecutionMapping = ExecutionMappings[maxIdIndex];
      } else {
        this.selectedExecutionMapping = null;
      }
    },
    showConfigDialog() {
      this.dialog = !this.dialog;
    },
    editConfiguration(configuration) {
      let alreadyParsed = false;
      // The first time a config is edited, it is parsed from string to an object
      if (typeof configuration.configuration == "string") {
        configuration.configuration = JSON.parse(configuration.configuration);
      } else if (typeof configuration.configuration == "object") {
        alreadyParsed = true;
      }

      switch (configuration.application.code) {
        case "PW":
          this.PWSymbolsEdited = true;
          this.selectedApplicationType = this.applicationTypeEnums.pricewatcher;
          this.currentDefinition = cloneDeep(configuration);
          this.currentDefinition.priceWatcherConfiguration =
              this.checkPWBackwardCompatibility(
                  this.currentDefinition.configuration
              );

          this.fetchAvailablePWSymbols(configuration.id);
          // allPricewatcherSymbols
          break;
        default:
          this.selectedApplicationType = this.applicationTypeEnums.general;
      }
      this.edit = true;
      this.add = false;

      // In case of  Price Watcher configuration -> no preprocessing is needed so return;
      if (
          this.selectedApplicationType === this.applicationTypeEnums.pricewatcher
      ) {
        this.showConfigDialog();
        return;
      }

      // REMOVE THIS when you are 100% sure that all clients have updated configurations (no ExcludeSynchronizersAndSchedulers field)
      // Handle old configurations e.g ExcludeSynchronizersAndSchedulers -> ExcludeServices
      if (
          configuration && configuration.configuration && configuration.configuration.Analytics && configuration.configuration?.Analytics["ExcludeSynchronizersAndSchedulers"]
      ) {
        configuration.configuration.Analytics.ExcludeServices =
            configuration.configuration.Analytics.ExcludeSynchronizersAndSchedulers;
        delete configuration.configuration.Analytics
            .ExcludeSynchronizersAndSchedulers;
      }

      this.analyticsModel = configuration.configuration.Analytics.Enabled;
      this.priceGuardModel = configuration.configuration.PriceGuard.Enabled;

      if (!alreadyParsed) {
        let ANConfig = configuration.configuration.Analytics;
        // Parse symbol multipliers from object to array
        let SMKeys = ANConfig.SymbolsMultipliers
            ? Object.keys(ANConfig.SymbolsMultipliers)
            : [];

        if (SMKeys.length) {
          ANConfig.SymbolsMultipliers = SMKeys.map((el) => {
            return {id: el, details: [el, ANConfig.SymbolsMultipliers[el]]};
          });
        } else ANConfig.SymbolsMultipliers = [];
      }

      configuration.configuration.Analytics.EodFloatingPnlOffsetTimes =
          this.parseEodFloatingPnlOffsetTimes(
              configuration.configuration.Analytics.EodFloatingPnlOffsetTimes
          );

      // preprocess journal filters + give it the default value if its undefined
      configuration.configuration.Analytics.JournalFilters =
          this.preprocessJournalFilters(configuration.configuration.Analytics);

      this.currentDefinition = Object.assign(
          cloneDeep(configuration),
          {
            configuration: this.checkBackwardCompatibility(
                cloneDeep(configuration.configuration)
            ),
          }
      );

      let quoteConnectionSelected = null;
      if (this.currentDefinition && this.currentDefinition.configuration && this.currentDefinition.configuration["WebSocket"]) {
        quoteConnectionSelected = "WebSocket";
      } else if (this.currentDefinition && this.currentDefinition.configuration && this.currentDefinition.configuration["Fix"]) {
        quoteConnectionSelected = "Fix";
      }

      if (quoteConnectionSelected === "WebSocket") {
        this.availableQuoteConnections = ["WebSocket"];
        this.quoteConnectionModel = "WebSocket";
      }

      if (quoteConnectionSelected === "Fix") {
        let encryptMethod =
            this.currentDefinition.configuration.Fix.EncryptMethod;
        this.currentEncryptionMethods = cloneDeep(encryptionMethods)
        if (this.currentEncryptionMethods.indexOf(encryptMethod) === -1)
          this.currentEncryptionMethods.push(encryptMethod)
      }

      // Set quoteConnectionSelected
      // In case there is no quoteConnection settings set, set it to default "Fix"
      let quoteConnectionSelectedObject = {
        text: quoteConnectionSelected === "Fix" || quoteConnectionSelected == null ? "Fix" : "Web Socket",
        value:
            quoteConnectionSelected === "Fix" || quoteConnectionSelected == null
                ? "Fix"
                : "WebSocket",
        enabled: true,
      };

      this.selectQuoteConnection(quoteConnectionSelectedObject)

      // TODO:
      // This the following is a better code solution then the above
      // configuration.configuration = this.checkBackwardCompatibility(
      //       configuration.configuration
      //     )
      // this.currentDefinition = cloneDeep(configuration))

      // Temporary solution for removing the reference definition object
      // so that Eods aren't nullified when dialog is closed
      // The correct solution would be to remove reference from the whole configuration object.
      this.currentDefinition.configuration.Analytics.EodFloatingPnlOffsetTimes =
          JSON.parse(
              JSON.stringify(
                  this.currentDefinition.configuration.Analytics
                      .EodFloatingPnlOffsetTimes
              )
          );

      this.showConfigDialog();
    },
    deleteConfig(confirmDeletion) {
      if (confirmDeletion) {
        ApplicationDefinitionService.delete(this.itemToDelete.id)
            .then(() => {
              this.confirmDialog = false;

              if (this.tableItems.length === 1) {
                let pageToFetch = this.page - 1;
                if (this.page > 1) {
                  this.page--;
                  pageToFetch--;
                }
                this.refreshConfigs({page: pageToFetch});
              } else this.refreshConfigs();
            })
            .then(() => {
              this.$notifier.info("Configuration deleted");
            })
            .catch((error) => {
              this.$notifier.error("Configuration could not be deleted", {
                error: error,
              });
            });
      } else this.confirmDialog = false;
    },
    addDefinition() {
      let appCode =
          this.selectedApplicationType === this.applicationTypeEnums.pricewatcher
              ? "PW"
              : "AN";

      let appId = this.applications.find((el) => el.code === appCode);

      let definitionToAdd = {
        description: this.currentDefinition.description,
        name: this.currentDefinition.name,
        server: {
          id: this.chosenServer.id,
        },
        application: {
          id: appId ? appId.id : 3, // 3 is the default id for AN
        },
      };

      // TODO: Fix the following workaraund
      // The following code is used to create a definition of a Service
      if (this.currentDefinition.executionType === "SERVICE") {
        if (
            this.selectedApplicationType === this.applicationTypeEnums.pricewatcher
        ) {
          definitionToAdd.configuration = JSON.stringify(
              this.currentDefinition.priceWatcherConfiguration
          );
        } else {
          if (this.currentDefinition && this.currentDefinition["priceWatcherConfiguration"])
            delete this.currentDefinition.priceWatcherConfiguration;

          definitionToAdd.configuration = JSON.stringify(
              this.currentDefinition.configuration
          );
        }

        definitionToAdd.executionType = this.currentDefinition.executionType;

        this.postNewConfig(definitionToAdd);
        this.chosenServer = {};
        this.dialog = !this.dialog;
        return;
      }

      definitionToAdd.configuration = JSON.parse(
          JSON.stringify(this.currentDefinition.configuration)
      );

      let ANconfiguration = JSON.parse(
          JSON.stringify(this.currentDefinition.configuration.Analytics)
      );
      ANconfiguration.ExecutionMappings = ANconfiguration.ExecutionMappings.map(
          (val) => {
            let loginsArray;
            if (typeof val.Logins == "string") {
              loginsArray = val.Logins.split(",");
            } else {
              loginsArray = val.Logins;
            }

            val.Logins = loginsArray.map((el) => parseInt(el, 10));

            val.Logins = val.Logins.filter((num) => {
              return !(num == null || isNaN(num));
            });
            return val;
          }
      );

      if (
          ANconfiguration.ExcludeServices.length &&
          typeof ANconfiguration.ExcludeServices == "string"
      ) {
        ANconfiguration.ExcludeServices =
            ANconfiguration.ExcludeServices.split(",");
      }

      if (
          ANconfiguration.SecondaryCalculationCurrencies.length &&
          typeof ANconfiguration.SecondaryCalculationCurrencies == "string"
      ) {
        ANconfiguration.SecondaryCalculationCurrencies =
            ANconfiguration.SecondaryCalculationCurrencies.replace(/ /g, '').split(",");
      }

      if (
          ANconfiguration.CalculationCurrenciesSuffixes.length &&
          typeof ANconfiguration.CalculationCurrenciesSuffixes == "string"
      ) {
        ANconfiguration.CalculationCurrenciesSuffixes =
            ANconfiguration.CalculationCurrenciesSuffixes.replace(/ /g, '').split(",");
      }

      if (
          ANconfiguration.IntermediateCurrencies.length &&
          typeof ANconfiguration.IntermediateCurrencies == "string"
      ) {
        ANconfiguration.IntermediateCurrencies =
            ANconfiguration.IntermediateCurrencies.replace(/ /g, '').split(",");
      }

      let ANconfigurationParsed = this.parseArrayString(
          ANconfiguration,
          "ExcludeLogins",
          false
      );
      ANconfiguration.ExcludeLogins = JSON.parse(
          JSON.stringify(ANconfigurationParsed.ExcludeLogins)
      );

      // Parse SymbolsMultipliers from arrray to object
      this.parseSymbolsMultipliers(ANconfiguration);

      definitionToAdd.configuration.Analytics = JSON.parse(
          JSON.stringify(ANconfiguration)
      );
      definitionToAdd.configuration.PriceGuard =
          this.currentDefinition.configuration.PriceGuard;

      definitionToAdd.configuration.PriceGuard.Enabled = this.priceGuardModel;
      definitionToAdd.configuration.Analytics.Enabled = this.analyticsModel;

      definitionToAdd.configuration.Analytics.EodFloatingPnlOffsetTimes =
          this.parseEodFloatingPnlOffsetTimesForBE(definitionToAdd.configuration);
      definitionToAdd.configuration.Analytics.JournalFilters =
          this.removeEmptyAndHelperJournalFiltersFields(
              definitionToAdd.configuration.Analytics.JournalFilters
          );

      definitionToAdd.configuration = JSON.stringify(
          definitionToAdd.configuration
      );

      this.postNewConfig(definitionToAdd);
      this.chosenServer = {};

      this.dialog = !this.dialog;
    },
    openDefinitionDialog() {
      if (this.isAdmin === true) {
        this.selectedApplicationType = this.applicationTypeEnums.general;
        this.currentDefinition = cloneDeep(defaultDefinition);

        let analyticsConfig = this.currentDefinition.configuration.Analytics;

        analyticsConfig.JournalFilters =
            this.preprocessJournalFilters(analyticsConfig);

        analyticsConfig.EodFloatingPnlOffsetTimes =
            this.parseEodFloatingPnlOffsetTimes(
                this.currentDefinition.configuration.Analytics
                    .EodFloatingPnlOffsetTimes,
                true
            );

        this.getServers();
        let loading = false;
        this.getApps(loading);
        this.add = true;
        this.edit = false;

        this.dialog = !this.dialog;
        setTimeout(() => {
          this.analyticsModel = true;
          this.priceGuardModel = true;
        }, 100);
      }
    },
    saveHandler(definitionId) {
      if (!this.$refs.confForm.validate()) {
        return;
      }
      if (this.add) {
        this.addDefinition();
      } else if (this.edit) {
        this.saveEditedConfiguration();
      }
    },
    selectAllPGSymbols() {
      let internalCurrentItems = this.$refs.PGSymbolsTable.internalCurrentItems;
      internalCurrentItems.forEach((el) => {
        if (!this.allPriceguardSymbols[el.index].checked)
          this.allPriceguardSymbols[el.index].checked = true;
      });
      this.recalculateSelectedPGSymbolsLength();
    },
    selectAllPWSymbols() {
      let internalCurrentItems = this.$refs.PWSymbolsTable.internalCurrentItems;
      internalCurrentItems.forEach((el) => {
        if (!this.allPricewatcherSymbols[el.index].checked)
          this.allPricewatcherSymbols[el.index].checked = true;
      });
      this.recalculateSelectedPWSymbolsLength();
    },
    deSelectAllPGSymbols() {
      let internalCurrentItems = this.$refs.PGSymbolsTable.internalCurrentItems;
      internalCurrentItems.forEach((el) => {
        if (this.allPriceguardSymbols[el.index].checked)
          this.allPriceguardSymbols[el.index].checked = false;
      });
      this.recalculateSelectedPGSymbolsLength();
    },
    deSelectAllPWSymbols() {
      let internalCurrentItems = this.$refs.PWSymbolsTable.internalCurrentItems;
      internalCurrentItems.forEach((el) => {
        if (this.allPricewatcherSymbols[el.index].checked)
          this.allPricewatcherSymbols[el.index].checked = false;
      });
      this.recalculateSelectedPWSymbolsLength();
    },
  },
  watch: {
    dialog(val) {
      if (!val) this.clearDialog();
      else {
        this.eodFloatingPnlOffsetTimesModel = "Days";
        this.JournalFiltersModel = "Filters";
        this.selectedJournalFilterParsers = [];
      }
    },
    journalFiltersDialogModel(val) {
      if (!val) {
        this.selectedJournalFilterParsers = [];
        this.currentJournalFilter = null;
        this.currentParserEditing = null;
      } else this.JournalFiltersModel = "Filters";
    },
  },
};
</script>
<style scoped src="../css/utilities/scoped/configurations.css"></style>
<style src="../css/utilities/configurations.css">
@import url("../css/utilities/globalCSS.css");
</style>
